import { t, tf } from "./i18n.js";
import { starteBullOff } from "./bull-off.js";
let p1LegThrows = [];
let p2LegThrows = [];
let botTimer501 = null;
let localP1Id = null;
let localP2Id = null;
let localP2AvatarUrl = null;
let isSubmittingThrow = false;
let nextLegTimer501 = null;
let isStartingNextLeg = false;
let lastRoomState = null;
// Bull-Off (15.08.2026): Wer das MATCH beginnt, 1 oder 2. Die Legs wechseln
// sich davon unberuehrt weiter ab - der Bull-Off verschiebt nur, bei wem die
// Reihe anfaengt.
let startspieler501 = 1;
let bullOff501 = null;

// FIX: Liest den Spielstand aus dem letzten DB-Sync statt aus dem DOM.
// Fallback auf das DOM, falls noch kein Sync stattgefunden hat.
function getOnlineScore(playerNum) {
  const key = playerNum === 1 ? "player1_score" : "player2_score";
  if (lastRoomState && Number.isFinite(lastRoomState[key])) {
    return lastRoomState[key];
  }
  const el = document.getElementById(playerNum === 1 ? "p1-score" : "p2-score");
  const fromDom = parseInt(el ? el.innerText : "");
  return Number.isFinite(fromDom) ? fromDom : startingScore501;
}

function getOnlineLegs(playerNum) {
  const key = playerNum === 1 ? "player1_legs" : "player2_legs";
  if (lastRoomState && Number.isFinite(lastRoomState[key])) {
    return lastRoomState[key];
  }
  const el = document.getElementById(
    playerNum === 1 ? "p1-legs-display" : "p2-legs-display",
  );
  return parseInt(el ? el.innerText : "") || 0;
}

// EINE Quelle fuer die Feldliste des Stats-Trackers (Alpha-Befund 13.08.2026).
// Vorher stand die Form doppelt im Code: hier UND als Ur-Zustand in app.js.
// Beim Erweitern (scoreFrequencies, first9*, highestFinish) wurde nur diese
// Stelle gepflegt - app.js behielt die alte Form. Jeder Pfad, der den
// Ur-Zustand erreichte (Reconnect nach Neuladen), crashte dann bei
// pStats.scoreFrequencies[x] und JEDER Wurf scheiterte mit
// "Wurf konnte nicht verarbeitet werden".
// Physisches Minimum an Darts fuer ein Leg mit dieser Startpunktzahl:
// jeder Dart hoechstens 60, der letzte (Doppel/Bullseye) hoechstens 50.
// 501 -> 9, 301 -> 6, 170 -> 3. Eine Quelle fuer Tracker (bestLeg) und
// Auswertung (stats501-erweitert.js prueft mit derselben Formel).
function mindestDarts501(start) {
  const s = Number(start) || 501;
  if (s <= 50) return 1;
  return Math.ceil((s - 50) / 60) + 1;
}

function statsFelder() {
  return {
    dartsCurrentLeg: 0,
    bestLeg: 0,
    highestFinish: 0,
    t100: 0,
    t140: 0,
    t180: 0,
    busts: 0,
    checkoutAttempts: 0,
    checkoutHits: 0,
    scoreFrequencies: {},
    first9Score: 0,
    first9Darts: 0,
  };
}

function resetStatsTracker() {
  statsTracker = { p1: statsFelder(), p2: statsFelder() };
}

// Ergaenzt fehlende Felder, ohne vorhandene Werte anzutasten. Faengt die
// zweite Luecke ab: prev_state.statsTrackerState aus der Datenbank (Undo)
// kann von einer aelteren Clientversion geschrieben worden sein und neuere
// Felder schlicht nicht enthalten.
function ergaenzeStatsFelder(pStats) {
  const soll = statsFelder();
  for (const feld in soll) {
    if (pStats[feld] === undefined) pStats[feld] = soll[feld];
  }
  return pStats;
}

// ── Finish-Regel & Double-In (Produkttest 29.08.2026) ──────────────────
// Vorher wurde Double-Out bei Board- und Tastatureingabe NICHT geprueft
// (kritischer Befund): boardCommit501/submitCalcDarts uebergaben nur die
// Summe, nur der Tracker lieferte erzwungenerBust. Jetzt reichen alle
// drei Eingabewege ihre Dartliste durch, und submit501Score prueft den
// letzten Dart gegen die Regel. Online gilt unveraendert der Standard
// (Double-Out) - die Auswahl unten liest nur das lokale Setup.
let finishRegel501 = "double"; // "double" | "master" | "straight"
let doubleIn501 = false;
let p1Eingecheckt501 = true;
let p2Eingecheckt501 = true;

function dartPunkte501(d) {
  return Number(d?.points ?? d?.val ?? 0) || 0;
}

/** Doppel im Sinne der Finish-Regel: D1-D20 oder Bullseye.
 *  Traegt jede der drei Dartformen: Board (multiplier/base), Tastatur
 *  (mult/base) und Tracker (mult/base); Bullseye ist ueberall base 50. */
function istDoppelDart501(d) {
  if (!d) return false;
  const mult = Number(d.mult ?? d.multiplier ?? 0);
  const basis = Number(d.base ?? 0);
  return mult === 2 || basis === 50;
}

function istTripleDart501(d) {
  if (!d) return false;
  return Number(d.mult ?? d.multiplier ?? 0) === 3;
}

/** Die im Spiel geltende Finish-Regel - EINE Quelle fuer submit501Score
 *  und das Pro-Dart-Urteil des Trackers (autoscore501Dart). */
function geltendeFinishRegel501() {
  return isLocal501 ? finishRegel501 : "double";
}

function startLocal501Game() {
  bestOfLegs = parseInt(document.getElementById("best-of-legs").value || 3);
  finishRegel501 =
    document.getElementById("sel-501-finish")?.value || "double";
  doubleIn501 = !!document.getElementById("chk-501-double-in")?.checked;
  startingScore501 = parseInt(
    document.getElementById("start-score-501").value || 501
  );
  localP1Name =
    document.getElementById("local-p1-name").value.trim() || t("js.app.001");
  localP2Name =
    document.getElementById("local-p2-name").value.trim() || t("js.app.002");
  // Host: wenn eingeloggt, immer speichern (Name darf frei sein)
  if (!isGuest && currentUser) {
    localP1Id = currentUser.id;
  } else {
    localP1Id = null;
  }

  // Falls jemand den Namen von P2 nach der Verifizierung manuell ändert -> ID löschen!
  const p2Input = document.getElementById("local-p2-name");
  if (localP2Id && !p2Input.disabled && localP2Name !== p2Input.value) {
    localP2Id = null;
  }
  isP2Bot = localP2Name.includes("[BOT]");
  localP1Legs = 0;
  localP2Legs = 0;
  p1TotalScore = 0;
  p2TotalScore = 0;
  p1Darts501 = 0;
  p2Darts501 = 0;
  p1DartsAtLegStart = 0;
  p2DartsAtLegStart = 0;
  currentMatchLog501 = [];
  p1LastThrow = "-";
  p2LastThrow = "-";
  isLocal501 = true;
  startspieler501 = 1;
  document.getElementById("online-lobby-screen").style.display = "none";
  document.getElementById("game-501-screen").style.display = "block";
  resetLegLocal();
  resetStatsTracker();

  // Spielwache: nur die Verlassen-Warnung (29.08.2026). Die Spiegelung des
  // 501-Zustands (Legs, Undo-Stack, Bull-Off, Bot) ist als offener Punkt
  // in UMSETZUNG_2026-08-29_PRODUKTTEST_PAKET.md vermerkt.
  spielwacheSpielGestartet("501", null);

  // Bull-Off zuletzt: Der Bildschirm muss stehen, bevor das Overlay
  // darueberlegt - und resetLegLocal() haette den ausgelosten Starter
  // sonst gleich wieder ueberschrieben.
  if (document.getElementById("chk-501-bulloff")?.checked) {
    starteBullOff({
      spieler: [localP1Name, localP2Name],
      // Der Bot wirft selbst - sonst muesste ein Mensch fuer ihn zielen,
      // und das waere keine Auslosung.
      onDran: (i) => { if (i === 1 && isP2Bot) botWirftBullOff(); },
      onFertig: (reihenfolge) => {
        startspieler501 = reihenfolge[0] + 1;
        resetLegLocal();
      },
      onAbbruch: () => { /* Vorgabe bleibt: Spieler 1 beginnt */ },
    });
  }
}

/** Bull-Off in einer Online-Partie.
 *
 *  Beide Spieler stehen an ihrem eigenen Board. Jeder wirft genau EINEN Dart
 *  bei sich, schickt den Abstand ueber den Kanal, und beide rechnen aus
 *  denselben zwei Zahlen dasselbe Ergebnis aus. Nur der Host schreibt danach
 *  `current_turn` - sonst schrieben zwei Clients dieselbe Zeile.
 *
 *  Beide oeffnen das Overlay: Der Gast kennt die Einstellung des Hosts nicht
 *  (sie steht in dessen Setup-Formular, nicht in der Tabelle). Wer nicht
 *  auslosen will, kommt ueber "Ohne Bull-Off starten" heraus. */
function starteOnlineBullOff(dbData) {
  if (isLocal501) return;
  if (isOnlineHost && !document.getElementById("chk-501-bulloff")?.checked) return;
  if (bullOff501?.offen?.()) return;

  const namen = [dbData.player1_name || t("js.app.001"), dbData.player2_name || t("js.app.002")];
  const meinIndex = amIPlayer1 ? 0 : 1;

  bullOff501 = starteBullOff({
    spieler: namen,
    werfen: [meinIndex], // an diesem Geraet wirft nur einer
    onWurf: (_i, abstand) => {
      realtimeSubscription?.send?.({
        type: "broadcast",
        event: "bulloff",
        payload: { p1: amIPlayer1, mm: abstand },
      });
    },
    onFertig: async (reihenfolge) => {
      startspieler501 = reihenfolge[0] + 1;
      if (!isOnlineHost) return;
      await _supabase
        .from("live_matches")
        .update({ current_turn: startspieler501 })
        .eq("room_code", currentRoomCode);
    },
    onAbbruch: () => { /* Vorgabe bleibt: Spieler 1 beginnt */ },
  });
}

/** Der Bot wirft seinen Bull-Off-Dart.
 *
 *  Streuung wie beim Bull-Ziel im Spiel: meistens nah, gelegentlich daneben.
 *  Bewusst KEINE Bevorzugung - der Bull-Off soll eine Auslosung sein, keine
 *  Spielstaerke. */
function botWirftBullOff() {
  setTimeout(() => {
    const winkel = Math.random() * Math.PI * 2;
    const radius = Math.random() * 40; // 0-40 mm um die Mitte
    window.autoScoreAdapter?.bulloff?.dart?.({
      base: 25, mult: 1, points: 25, label: "BULL",
      heat: { x_mm: Math.cos(winkel) * radius, y_mm: Math.sin(winkel) * radius },
    });
  }, 700);
}

function resetLegLocal() {
  localP1Score = startingScore501;
  localP2Score = startingScore501;
  // Double-In gilt je Leg neu (29.08.2026).
  p1Eingecheckt501 = !doubleIn501;
  p2Eingecheckt501 = !doubleIn501;
  p1LegThrows = [];
  p2LegThrows = [];

  // 1. ZUERST DIE NAMEN UND AVATARE SETZEN!
  document.getElementById("p1-name").innerText = localP1Name;
  document.getElementById("p2-name").innerText = localP2Name;

  let avatarP1 = document.getElementById("avatar-p1");
  let avatarP2 = document.getElementById("avatar-p2");

  if (avatarP1) {
    let p1Img =
      !isGuest && currentUser && localP1Name === myOnlineName
        ? currentUser.user_metadata?.avatar_url
        : null;
    avatarP1.src =
      p1Img || `https://api.dicebear.com/7.x/avataaars/svg?seed=${localP1Name}`;
  }
  if (avatarP2) {
    // NEU: Nutze den gespeicherten Avatar aus der Verifizierung (falls vorhanden)
    // Wenn nicht (z.B. unregistrierter Gast), nutze den Dicebear-Fallback
    avatarP2.src =
      localP2AvatarUrl ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${localP2Name}`;
  }

  // 2. DANN ERST DIE HISTORIE LADEN!
  updateThrowHistoryUI();

  history501Stack = [];
  // FIX: Ohne diese beiden Zeilen rechnet der Leg-Average ab Leg 2 mit den
  // Darts des gesamten Matches, waehrend der Zaehler legbezogen bleibt.
  p1DartsAtLegStart = p1Darts501;
  p2DartsAtLegStart = p2Darts501;
  // +(startspieler501 - 1): Beginnt Spieler 2 das Match, ist die
  // Abwechslung um eins verschoben - das erste Leg gehoert ihm, das zweite
  // wieder Spieler 1. Ohne den Versatz haette der Bull-Off nur das erste
  // Leg betroffen und waere ab Leg 2 stillschweigend weg.
  localCurrentTurn =
    (localP1Legs + localP2Legs + (startspieler501 - 1)) % 2 === 0 ? 1 : 2;
  isMyTurn = true;
  statsTracker.p1.dartsCurrentLeg = 0;
  statsTracker.p2.dartsCurrentLeg = 0;
  document.getElementById("win-overlay-501").style.display = "none";

  updateLocalTurnHighlight();
  update501QoL(localP1Score, localP2Score);

  // Wenn Spieler 2 ein Bot ist und er anfangen darf, spielt er automatisch los!
  if (localCurrentTurn === 2 && isP2Bot) {
    setTimeout(() => play501BotTurn(), 800);
  }
}

function update501QoL(p1Score, p2Score) {
  document.getElementById("p1-score").innerText = p1Score;
  document.getElementById("p2-score").innerText = p2Score;

  let p1MatchAvg =
    p1Darts501 > 0 ? ((p1TotalScore / p1Darts501) * 3).toFixed(2) : "0.00";
  let p2MatchAvg =
    p2Darts501 > 0 ? ((p2TotalScore / p2Darts501) * 3).toFixed(2) : "0.00";

  let p1LegDarts = p1Darts501 - p1DartsAtLegStart;
  let p2LegDarts = p2Darts501 - p2DartsAtLegStart;

  let p1LegAvg =
    p1LegDarts > 0
      ? (((startingScore501 - p1Score) / p1LegDarts) * 3).toFixed(2)
      : "0.00";
  let p2LegAvg =
    p2LegDarts > 0
      ? (((startingScore501 - p2Score) / p2LegDarts) * 3).toFixed(2)
      : "0.00";

  if (document.getElementById("p1-match-avg")) {
    document.getElementById("p1-match-avg").innerText = p1MatchAvg;
    document.getElementById("p1-leg-avg").innerText = p1LegAvg;
    document.getElementById("p2-match-avg").innerText = p2MatchAvg;
    document.getElementById("p2-leg-avg").innerText = p2LegAvg;
  }
  document.getElementById("p1-darts").innerText = tf("js.friends.011", { p1: p1Darts501 });
  document.getElementById("p2-darts").innerText = tf("js.friends.011", { p1: p2Darts501 });
  document.getElementById("p1-checkout").innerText = getCheckoutPath(p1Score);
  document.getElementById("p2-checkout").innerText = getCheckoutPath(p2Score);

  if (document.getElementById("p1-legs-display"))
    document.getElementById("p1-legs-display").innerText = localP1Legs;
  if (document.getElementById("p2-legs-display"))
    document.getElementById("p2-legs-display").innerText = localP2Legs;
  faerbeLastThrow("p1-last-throw", p1LastThrow);
  faerbeLastThrow("p2-last-throw", p2LastThrow);

  const undoBtn = document.getElementById("btn-undo-501");
  if (history501Stack.length > 0 && isLocal501) {
    undoBtn.style.display = "block";
  } else {
    undoBtn.style.display = "none";
  }
}

function updateLocalTurnHighlight() {
  if (localCurrentTurn === 1) {
    document.getElementById("p1-box").classList.remove("inactive");
    document.getElementById("p2-box").classList.add("inactive");
  } else {
    document.getElementById("p2-box").classList.remove("inactive");
    document.getElementById("p1-box").classList.add("inactive");
  }
  current501Input = "";
  update501Display();
}

function getCheckoutPath(score) {
  if (
    score > 170 ||
    score < 2 ||
    [169, 168, 166, 165, 163, 162, 159].includes(score)
  )
    return "";

  const checkouts = {
    170: "T20 T20 BULL",
    167: "T20 T19 BULL",
    164: "T20 T18 BULL",
    161: "T20 T17 BULL",
    160: "T20 T20 D20",
    158: "T20 T20 D19",
    157: "T20 T19 D20",
    156: "T20 T20 D18",
    155: "T20 T19 D19",
    154: "T20 T18 D20",
    153: "T20 T19 D18",
    152: "T20 T20 D16",
    151: "T20 T17 D20",
    150: "T20 T18 D18",
    149: "T20 T19 D16",
    148: "T20 T16 D20",
    147: "T20 T17 D18",
    146: "T20 T18 D16",
    145: "T20 T15 D20",
    144: "T20 T20 D12",
    143: "T20 T17 D16",
    142: "T20 T14 D20",
    141: "T20 T15 D18",
    140: "T20 T20 D10",
    139: "T20 T13 D20",
    138: "T20 T18 D12",
    137: "T20 T15 D16",
    136: "T20 T20 D8",
    135: "T20 T17 D12",
    134: "T20 T14 D16",
    133: "T20 T19 D8",
    132: "T20 T16 D12",
    131: "T20 T13 D16",
    130: "T20 T20 D5",
    129: "T19 T16 D12",
    128: "T18 T14 D16",
    127: "T20 T17 D8",
    126: "T19 T19 D6",
    125: "BULL T17 D12",
    124: "T20 T16 D8",
    123: "T19 T16 D9",
    122: "T18 T20 D4",
    121: "T20 T15 D8",
    120: "T20 20 D20",
    119: "T19 T10 D16",
    118: "T20 18 D20",
    117: "T20 17 D20",
    116: "T20 16 D20",
    115: "T20 15 D20",
    114: "T20 14 D20",
    113: "T20 13 D20",
    112: "T20 12 D20",
    111: "T20 11 D20",
    110: "T20 10 D20",
    109: "T19 12 D20",
    108: "T20 16 D16",
    107: "T19 10 D20",
    106: "T20 10 D18",
    105: "T19 16 D16",
    104: "T18 10 D20",
    103: "T19 10 D18",
    102: "T20 10 D16",
    101: "T17 10 D20",
    100: "T20 D20",
    99: "T19 10 D16",
    98: "T20 D19",
    97: "T19 D20",
    96: "T20 D18",
    95: "T19 D19",
    94: "T18 D20",
    93: "T19 D18",
    92: "T20 D16",
    91: "T17 D20",
    90: "T18 D18",
    89: "T19 D16",
    88: "T16 D20",
    87: "T17 D18",
    86: "T18 D16",
    85: "T15 D20",
    84: "T20 D12",
    83: "T17 D16",
    82: "BULL D16",
    81: "T15 D18",
    80: "T20 D10",
    79: "T13 D20",
    78: "T18 D12",
    77: "T15 D16",
    76: "T20 D8",
    75: "T17 D12",
    74: "T14 D16",
    73: "T19 D8",
    72: "T16 D12",
    71: "T13 D16",
    70: "T18 D8",
    69: "T15 D12",
    68: "T20 D4",
    67: "T17 D8",
    66: "10 16 D20",
    65: "T19 D4",
    64: "16 16 D16",
    63: "T13 D12",
    62: "10 12 D20",
    61: "T15 D8",
    60: "20 D20",
    59: "19 D20",
    58: "18 D20",
    57: "17 D20",
    56: "16 D20",
    55: "15 D20",
    54: "14 D20",
    53: "13 D20",
    52: "12 D20",
    51: "11 D20",
    50: "BULLSEYE",
    49: "9 D20",
    48: "16 D16",
    47: "15 D16",
    46: "14 D16",
    45: "13 D16",
    44: "12 D16",
    43: "3 D20",
    42: "10 D16",
    41: "9 D16",
    // NEU: Spezielle Wege für ungerade Reste unter 40
    39: "7 D16",
    37: "5 D16",
    35: "3 D16",
    33: "1 D16",
    31: "15 D8",
    29: "13 D8",
    27: "11 D8",
    25: "9 D8",
    23: "7 D8",
    21: "5 D8",
    19: "3 D8",
    17: "1 D8",
    15: "7 D4",
    13: "5 D4",
    11: "3 D4",
    9: "1 D4",
    7: "3 D2",
    5: "1 D2",
    3: "1 D1",
  };

  if (checkouts[score]) return checkouts[score];

  // Automatischer Fallback für alle geraden Zahlen bis 40
  if (score <= 40 && score % 2 === 0) return `D${score / 2}`;

  return "";
}

function undo501Turn() {
  if (document.activeElement) document.activeElement.blur();
  if (history501Stack.length === 0) return;

  // 1. Bot sofort stoppen, bevor wir den State ändern
  if (botTimer501) {
    clearTimeout(botTimer501);
    botTimer501 = null;
  }

  const lastState = history501Stack.pop();

  if (lastState.statsTrackerState) {
    statsTracker = lastState.statsTrackerState;
  }

  localP1Score = lastState.p1Score;
  localP2Score = lastState.p2Score;
  p1Darts501 = lastState.p1Darts;
  p2Darts501 = lastState.p2Darts;
  localCurrentTurn = lastState.turn;

  p1LastThrow = lastState.p1Last || "-";
  p2LastThrow = lastState.p2Last || "-";
  p1TotalScore = lastState.p1Total || 0;
  p2TotalScore = lastState.p2Total || 0;

  p1LegThrows = lastState.p1Throws || [];
  p2LegThrows = lastState.p2Throws || [];

  updateThrowHistoryUI();
  document.getElementById("p1-score").innerText = localP1Score;
  document.getElementById("p2-score").innerText = localP2Score;
  updateLocalTurnHighlight();
  update501QoL(localP1Score, localP2Score);

  // UI entsperren
  const numpad = document.querySelector(".numpad-grid");
  if (numpad) numpad.style.pointerEvents = "auto";

  // Falls nach dem Undo wieder der Bot dran ist -> neu triggern
  if (localCurrentTurn === 2 && isP2Bot && isLocal501) {
    play501BotTurn();
  }
}

async function hostOnlineGame() {
  isLocal501 = false;
  myOnlineName = document.getElementById("online-player-name").value.trim();
  if (!myOnlineName) return showToast(t("js.g501.001"), "warning");
  currentRoomCode = Math.random().toString(36).substring(2, 6).toUpperCase();
  amIPlayer1 = true;
  bestOfLegs = parseInt(document.getElementById("best-of-legs").value || 3);
  startingScore501 = parseInt(
    document.getElementById("start-score-501").value || 501
  );
  p1TotalScore = 0;
  p2TotalScore = 0;
  p1Darts501 = 0;
  p2Darts501 = 0;
  p1DartsAtLegStart = 0;
  p2DartsAtLegStart = 0;
  currentMatchLog501 = [];
  resetStatsTracker();
  let myAvatar = null;
  if (!isGuest && currentUser && currentUser.user_metadata?.avatar_url) {
    myAvatar = currentUser.user_metadata.avatar_url;
  }

  // --- NEU: Kamera, Öffentlich & Host Average ---
  let cameraReqEl = document.getElementById("chk-camera-required");
  let cameraRequired = cameraReqEl ? cameraReqEl.checked : false;

  let isPublicEl = document.getElementById("chk-is-public");
  let isPublic = isPublicEl ? isPublicEl.checked : true;

  let hostAvg = null;
  if (!isGuest && currentUser) {
    const { data: statsData } = await _supabase
      .from("stats_501")
      .select("total_score_thrown, total_darts_thrown")
      .eq("user_id", currentUser.id)
      .maybeSingle();

    if (statsData && statsData.total_darts_thrown > 0) {
      hostAvg =
        (statsData.total_score_thrown / statsData.total_darts_thrown) * 3;
    }
  }

  const { error } = await _supabase.from("live_matches").insert([
    {
      room_code: currentRoomCode,
      player1_name: myOnlineName,
      player1_avatar: myAvatar,
      // NEU 08.08.2026: Wem gehoert dieser Raum?
      //
      // Bis dahin hatte live_matches keine einzige Spalte, die das sagte -
      // nur Spielernamen als Text. Eine RLS-Regel kann damit nicht
      // ausdruecken "nur diese zwei duerfen schreiben", und tatsaechlich
      // standen dort sieben Regeln, deren Bedingung samt und sonders
      // `true` lautete: Jeder Angemeldete konnte in jedes laufende Match
      // schreiben und es loeschen.
      //
      // Die Migration (supabase/02_fix_punkt4.sql) hat die Spalten und die
      // Regeln gebracht. Ohne DIESE Zeile bliebe der Raum aber
      // besitzerlos - und besitzerlose Raeume laesst die neue Regel
      // weiterhin fuer alle offen, damit reine Gastpartien
      // weiterfunktionieren. Der Schutz greift also erst hier.
      //
      // null fuer Gaeste ist Absicht, nicht Nachlaessigkeit: Ohne Konto
      // gibt es keine user_id, an der eine Regel ansetzen koennte.
      // live_secure_matches macht es seit jeher genauso.
      host_user_id: !isGuest && currentUser ? currentUser.id : null,
      status: "waiting",
      best_of_legs: bestOfLegs,
      starting_score: startingScore501,
      player1_score: startingScore501,
      player2_score: startingScore501,
      player1_legs: 0,
      player2_legs: 0,
      player1_last_score: "-",
      player2_last_score: "-",
      camera_required: cameraRequired,
      is_public: isPublic, // NEU: Speichert, ob die Lobby in der Liste erscheint
      host_avg: hostAvg,
    },
  ]);

  if (error) return showToast(t("js.auth.010") + error.message, "error");

  openOnlineLobby(currentRoomCode, myOnlineName, null, true);
  listenForOpponent(currentRoomCode);
}

async function joinOnlineGame() {
  isLocal501 = false;
  myOnlineName = document.getElementById("online-player-name").value.trim();
  const codeInput = document
    .getElementById("join-room-code")
    .value.trim()
    .toUpperCase();
  if (!myOnlineName) return showToast(t("js.g501.001"), "warning");
  if (!codeInput) return showToast(t("js.g501.002"), "warning");

  let { data: room, error } = await _supabase
    .from("live_matches")
    .select("*")
    .eq("room_code", codeInput)
    .single();
  if (error || !room) return showToast(t("js.g501.003"), "error");
  if (room.status !== "waiting")
    return showToast(t("js.g501.004"), "warning");

  resetStatsTracker();
  amIPlayer1 = false;
  currentRoomCode = codeInput;
  bestOfLegs = room.best_of_legs || 3;
  startingScore501 = room.starting_score || 501;
  p1TotalScore = 0;
  p2TotalScore = 0;
  p1Darts501 = 0;
  p2Darts501 = 0;
  p1DartsAtLegStart = 0;
  p2DartsAtLegStart = 0;
  currentMatchLog501 = [];
  let myAvatar = null;
  if (!isGuest && currentUser && currentUser.user_metadata?.avatar_url) {
    myAvatar = currentUser.user_metadata.avatar_url;
  }

  await _supabase
    .from("live_matches")
    .update({
      player2_name: myOnlineName,
      player2_avatar: myAvatar,
      // Siehe host_user_id in createOnlineGame. Dieses UPDATE ist zugleich
      // der Grund, warum die neue Regel wartende Raeume offen laesst:
      // Beitreten heisst, einen fremden Raum zu beschreiben. Sobald hier
      // ein Wert steht, ist der Raum besetzt und nur noch fuer die beiden
      // Beteiligten schreibbar.
      guest_user_id: !isGuest && currentUser ? currentUser.id : null,
      last_action: t("js.g501.026"),
    })
    .eq("room_code", codeInput);

  // ---> NEU: Setzt den Gast in die Lobby
  openOnlineLobby(codeInput, room.player1_name, myOnlineName, false);
  listenForOpponent(currentRoomCode);
}

async function cancelLobby() {
  await cancel501Game(true);
}

function sync501UI(dbData) {
  // FIX: Letzten DB-Stand merken. Vorher wurden die Punktestaende im
  // Online-Modus aus dem DOM zurueckgelesen ("Sende..." -> NaN).
  lastRoomState = dbData;

  // 1. ZUERST DIE NAMEN UND AVATARE SETZEN!
  document.getElementById("p1-name").innerText = dbData.player1_name;
  document.getElementById("p2-name").innerText = dbData.player2_name;

  let avatarP1 = document.getElementById("avatar-p1");
  let avatarP2 = document.getElementById("avatar-p2");

  if (avatarP1) {
    avatarP1.src =
      dbData.player1_avatar ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${dbData.player1_name}`;
  }
  if (avatarP2) {
    avatarP2.src =
      dbData.player2_avatar ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${dbData.player2_name}`;
  }

  // 2. DANN WÜRFE BERECHNEN UND HISTORIE LADEN
  if (!isLocal501) {
    if (
      dbData.player1_score === startingScore501 &&
      dbData.player2_score === startingScore501 &&
      dbData.player1_darts === 0 &&
      dbData.player2_darts === 0
    ) {
      p1LegThrows = [];
      p2LegThrows = [];
    } else {
      // Hat der Gegner geworfen?
      if (amIPlayer1 && dbData.player2_darts > p2Darts501) {
        p2LegThrows.push({
          old: parseInt(document.getElementById("p2-score").innerText),
          thrown: dbData.player2_last_score,
          new: dbData.player2_score,
        });
        meldeGegnerWurf501(2, dbData.player2_last_score, dbData.player2_score);
      } else if (!amIPlayer1 && dbData.player1_darts > p1Darts501) {
        p1LegThrows.push({
          old: parseInt(document.getElementById("p1-score").innerText),
          thrown: dbData.player1_last_score,
          new: dbData.player1_score,
        });
        meldeGegnerWurf501(1, dbData.player1_last_score, dbData.player1_score);
      }
      // Hat der Gegner "Undo" gedrückt?
      if (dbData.player1_darts < p1Darts501) p1LegThrows.pop();
      if (dbData.player2_darts < p2Darts501) p2LegThrows.pop();
    }
    updateThrowHistoryUI();
  }

  document.getElementById("p1-score").innerText = dbData.player1_score;
  document.getElementById("p2-score").innerText = dbData.player2_score;

  p1Darts501 = dbData.player1_darts || 0;
  p2Darts501 = dbData.player2_darts || 0;

  p1TotalScore = Math.round(((dbData.player1_avg || 0) / 3) * p1Darts501);
  p2TotalScore = Math.round(((dbData.player2_avg || 0) / 3) * p2Darts501);

  p1LastThrow = dbData.player1_last_score || "-";
  p2LastThrow = dbData.player2_last_score || "-";
  localP1Legs = dbData.player1_legs || 0;
  localP2Legs = dbData.player2_legs || 0;

  let p1LegDarts = p1Darts501 - p1DartsAtLegStart;
  let p2LegDarts = p2Darts501 - p2DartsAtLegStart;
  let p1LegAvg =
    p1LegDarts > 0
      ? (((startingScore501 - dbData.player1_score) / p1LegDarts) * 3).toFixed(
          2
        )
      : "0.00";
  let p2LegAvg =
    p2LegDarts > 0
      ? (((startingScore501 - dbData.player2_score) / p2LegDarts) * 3).toFixed(
          2
        )
      : "0.00";

  if (document.getElementById("p1-match-avg")) {
    document.getElementById("p1-match-avg").innerText = dbData.player1_avg
      ? dbData.player1_avg.toFixed(2)
      : "0.00";
    document.getElementById("p1-leg-avg").innerText = p1LegAvg;
    document.getElementById("p2-match-avg").innerText = dbData.player2_avg
      ? dbData.player2_avg.toFixed(2)
      : "0.00";
    document.getElementById("p2-leg-avg").innerText = p2LegAvg;
  }

  document.getElementById("p1-darts").innerText = tf("js.friends.011", { p1: p1Darts501 });
  document.getElementById("p2-darts").innerText = tf("js.friends.011", { p1: p2Darts501 });

  document.getElementById("p1-checkout").innerText = getCheckoutPath(
    dbData.player1_score
  );
  document.getElementById("p2-checkout").innerText = getCheckoutPath(
    dbData.player2_score
  );

  if (document.getElementById("p1-legs-display"))
    document.getElementById("p1-legs-display").innerText =
      dbData.player1_legs || 0;
  if (document.getElementById("p2-legs-display"))
    document.getElementById("p2-legs-display").innerText =
      dbData.player2_legs || 0;
  faerbeLastThrow("p1-last-throw", dbData.player1_last_score || "-");
  faerbeLastThrow("p2-last-throw", dbData.player2_last_score || "-");

  const warMeinZug = isMyTurn;
  if (dbData.current_turn === 1) {
    document.getElementById("p1-box").classList.remove("inactive");
    document.getElementById("p2-box").classList.add("inactive");
    isMyTurn = amIPlayer1;
  } else {
    document.getElementById("p2-box").classList.remove("inactive");
    document.getElementById("p1-box").classList.add("inactive");
    isMyTurn = !amIPlayer1;
  }
  current501Input = "";
  // Alpha-Befund 13.08.2026: Beim ZUGWECHSEL auch Rechner- und Board-
  // eingabe leeren - dort angesammelte Darts gehoeren zu einem Zug, den
  // es nicht mehr gibt. Bewusst NUR beim Wechsel (nicht bei jedem Sync,
  // der auch waehrend der eigenen Aufnahme eintrifft) und bewusst NICHT
  // fuer das Auto-Scoring: Dessen Pfeile bleiben absichtlich stehen,
  // damit man sie nach dem Zugwechsel bestaetigen kann (Befund 09.08.).
  if (warMeinZug !== isMyTurn) {
    if (typeof resetCalcState === "function") resetCalcState();
    if (typeof window.boardReset501 === "function") window.boardReset501();
  }
  update501Display();

  const undoBtn = document.getElementById("btn-undo-501");
  if (!isLocal501) {
    undoBtn.style.display = !isMyTurn ? "block" : "none";
  }
}

function append501Input(num) {
  if (!isLocal501 && !isMyTurn) return;
  if (current501Input.length >= 3) return;
  current501Input += num;
  if (parseInt(current501Input) > 180) {
    showToast(t("js.g501.005"), "error");
    current501Input = "";
    update501Display();
    return;
  }
  update501Display();
}

function set501Input(val) {
  if (!isLocal501 && !isMyTurn) return;
  current501Input = val;
  update501Display();
}

function delete501Input() {
  if (!isLocal501 && !isMyTurn) return;
  current501Input = current501Input.slice(0, -1);
  update501Display();
}

function update501Display() {
  const display = document.getElementById("input-display-501");
  if (!isLocal501 && !isMyTurn) {
    display.innerText = t("js.g501.006");
    display.style.color = "#888";
  } else if (current501Input === "") {
    let activeName = t("js.g501.027");
    if (isLocal501) {
      activeName = localCurrentTurn === 1 ? localP1Name : localP2Name;

      // NEU: Kürzt den Bot-Namen im großen Display ab!
      if (activeName.includes("[BOT]")) {
        activeName = t("js.g501.032");
      }

      display.innerText = tf("js.g501.019", { p1: activeName });
    } else {
      display.innerText = activeName;
    }
    display.style.color = "var(--accent-blue)";
  } else {
    display.innerText = current501Input;
    display.style.color = "white";
  }
}

function askCheckoutOverlay(question, minVal, maxVal, allowCancel = false) {
  return new Promise((resolve) => {
    // Auto-Skip nur, wenn man NICHT abbrechen darf (z.B. bei der Folgefrage)
    if (minVal === maxVal && !allowCancel) return resolve(minVal);

    // ALLE Eingabemethoden verstecken (Numpad UND Taschenrechner)
    const numpadContainer = document.getElementById("numpad-container-501");
    const calcContainer = document.getElementById("calc-container-501");

    // Fallback für alte HTML-Struktur (z.B. falls es im Party-Modus aufgerufen wird)
    const presetGrid = document.querySelector("#game-501-screen .preset-grid");
    const numpadGrid = document.querySelector("#game-501-screen .numpad-grid");

    if (numpadContainer) numpadContainer.style.display = "none";
    if (calcContainer) calcContainer.style.display = "none";
    if (presetGrid && !numpadContainer) presetGrid.style.display = "none";
    if (numpadGrid && !numpadContainer) numpadGrid.style.display = "none";

    const overlay = document.getElementById("checkout-overlay");
    document.getElementById("checkout-question").innerText = question;

    const btnContainer = document.getElementById("checkout-buttons");
    btnContainer.innerHTML = "";
    btnContainer.style.display = "flex";
    btnContainer.style.flexWrap = "wrap";
    btnContainer.style.gap = "10px";

    // HILFSFUNKTION: Stellt das richtige Eingabefeld wieder her
    const restoreInput = () => {
      overlay.style.display = "none";
      if (typeof inputMode501 !== "undefined") {
        // Prüft, welcher Modus gerade aktiv ist
        if (numpadContainer)
          numpadContainer.style.display =
            inputMode501 === "numpad" ? "block" : "none";
        if (calcContainer)
          calcContainer.style.display =
            inputMode501 === "calc" ? "block" : "none";
      } else {
        // Fallback
        if (presetGrid) presetGrid.style.display = "grid";
        if (numpadGrid) numpadGrid.style.display = "grid";
      }
    };

    // Standard Nummern-Buttons generieren
    for (let i = minVal; i <= maxVal; i++) {
      let btn = document.createElement("button");
      btn.className = "num-btn";
      btn.style.background = "var(--accent-green)";
      btn.style.color = "black";
      btn.style.flex = "1";
      btn.style.minWidth = "60px";
      btn.innerText = i;
      btn.onclick = () => {
        restoreInput();
        resolve(i);
      };
      btnContainer.appendChild(btn);
    }

    // Den roten "Verrechnet" Button hinzufügen
    if (allowCancel) {
      let cancelBtn = document.createElement("button");
      cancelBtn.className = "num-btn";
      cancelBtn.style.background = "var(--accent-red)";
      cancelBtn.style.color = "white";
      cancelBtn.style.flexBasis = "100%";
      cancelBtn.style.padding = "15px";
      cancelBtn.style.fontSize = "1.1em";
      cancelBtn.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-right: 6px;"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Halt, verrechnet!';
      cancelBtn.onclick = () => {
        restoreInput();
        resolve("CANCEL");
      };
      btnContainer.appendChild(cancelBtn);
    }

    overlay.style.display = "flex";
  });
}

function updateThrowHistoryUI() {
  let p1Container = document.getElementById("side-history-list-p1");
  let p2Container = document.getElementById("side-history-list-p2");
  if (!p1Container || !p2Container) return;

  // Setzt die aktuellen Namen in die Kopfzeile der Historie
  document.getElementById("history-p1-name").innerText =
    document.getElementById("p1-name").innerText;
  document.getElementById("history-p2-name").innerText =
    document.getElementById("p2-name").innerText;

  // --- HISTORIE P1 KÜRZEN AUF MAX. 5 ---
  let displayP1 = p1LegThrows;
  if (displayP1.length > 5) {
    displayP1 = displayP1.slice(-5); // Schneidet alles bis auf die letzten 5 Würfe ab
  }

  let html1 = "";
  for (let t of displayP1) {
    html1 += `<div style="display:flex; justify-content:space-between; padding:8px 10px; background:#2a2a2a; margin-bottom:5px; border-radius:6px; font-size: 0.9em; color:#ccc;">
                <span>${t.old} &rarr; <b style="color:white;">${t.new}</b></span>
                <span style="color:var(--accent-blue); font-weight:bold;">[${t.thrown}]</span>
              </div>`;
  }
  p1Container.innerHTML = html1;

  // --- HISTORIE P2 KÜRZEN AUF MAX. 5 ---
  let displayP2 = p2LegThrows;
  if (displayP2.length > 5) {
    displayP2 = displayP2.slice(-5);
  }

  // Liste für Spieler 2 (Rechts) aufbauen
  let html2 = "";
  for (let t of displayP2) {
    html2 += `<div style="display:flex; justify-content:space-between; padding:8px 10px; background:#2a2a2a; margin-bottom:5px; border-radius:6px; font-size: 0.9em; color:#ccc;">
                <span style="color:var(--accent-blue); font-weight:bold;">[${t.thrown}]</span>
                <span><b style="color:white;">${t.new}</b> &larr; ${t.old}</span>
              </div>`;
  }
  p2Container.innerHTML = html2;

  // Scrollt automatisch zum neuesten Wurf nach unten
  p1Container.scrollTop = p1Container.scrollHeight;
  p2Container.scrollTop = p2Container.scrollHeight;

  // Best-of-Text aktualisieren
  if (document.getElementById("match-format-display")) {
    document.getElementById(
      "match-format-display"
    ).innerText = tf("js.g501.028", { p1: bestOfLegs });
  }
}

// Rueckgabe: true  = Aufnahme wurde gewertet
//            false = abgelehnt (nicht am Zug, ungueltig, DB-Fehler)
//
// WARUM UEBERHAUPT EINE RUECKGABE (Alphatest 09.08.2026)
// autoscore.js leerte die drei erkannten Pfeile, BEVOR diese Funktion
// entschied. Jeder frueher Ausstieg hier vernichtete damit die Aufnahme
// still: Der Spieler warf, zog die Pfeile - und nichts passierte. Genau
// so kam der Befund "der Score wird nicht ins Spiel uebertragen"
// zustande. Mit der Rueckgabe kann der Aufrufer die Aufnahme behalten.
async function submit501Score(presetScore = null, optionen = {}) {
  if (isSubmittingThrow) return false;
  isSubmittingThrow = true;

  try {
    // 1. NEU: Erlaubt Preset-Buttons (falls du welche nutzt) und fängt das Double-Click-Problem stumm ab!
    let scoreStr =
      presetScore !== null ? presetScore.toString() : current501Input;
    if (scoreStr === "" || scoreStr === null) return false;

    if (!isLocal501 && !isMyTurn) {
      // Vorher: stummes return. Fuer den Ziffernblock war das richtig -
      // die Tasten sind ohnehin gesperrt. Fuer das Auto-Scoring nicht:
      // Der Tracker meldet weiter, und der Spieler sieht keinen Grund,
      // warum sein Wurf verschwindet. Der Wurf wird weiterhin NICHT
      // gewertet - so gewollt, solange der Gegner am Zug ist.
      if (presetScore !== null) {
        showToast(t("js.g501.007"), "warning");
      }
      return false;
    }

    let score = parseInt(scoreStr);

    // Fängt wirkliche Fehleingaben ab (z.B. Buchstaben)
    if (isNaN(score)) {
      showToast(t("js.g501.005"), "error");
      current501Input = "";
      update501Display();
      return false;
    }

    if (score < 0 || score > 180) {
      showToast(t("js.g501.008"), "error");
      current501Input = "";
      update501Display();
      return false;
    }

    const impossibleScores = [163, 166, 169, 172, 173, 175, 176, 178, 179];
    if (impossibleScores.includes(score)) {
      showToast(tf("js.g501.020", { p1: score }), "warning");
      current501Input = "";
      update501Display();
      return false;
    }

    let currentPoints = isLocal501
      ? localCurrentTurn === 1
        ? localP1Score
        : localP2Score
      : getOnlineScore(amIPlayer1 ? 1 : 2);

    // Wer wirft gerade? JETZT merken, nicht spaeter: Im lokalen Spiel ist
    // localCurrentTurn am Ende dieser Funktion bereits auf den NAECHSTEN
    // Spieler weitergeschaltet - eine Ansage haette dann den Falschen
    // genannt. Gebraucht von der Wurfmeldung unten (caller.js).
    const werferNummer = isLocal501 ? localCurrentTurn : amIPlayer1 ? 1 : 2;
    const werferName = isLocal501
      ? werferNummer === 1
        ? localP1Name
        : localP2Name
      : document.getElementById(`p${werferNummer}-name`)?.innerText || "";

    const bogeyFinishes = [169, 168, 166, 165, 163, 162, 159];
    if (
      geltendeFinishRegel501() === "double" &&
      score === currentPoints &&
      bogeyFinishes.includes(score)
    ) {
      showToast(
        tf("js.g501.021", { p1: score }),
        "warning",
      );
      current501Input = "";
      update501Display();
      return false;
    }

    // Dartliste der Aufnahme, wenn der Eingabeweg sie kennt (Board,
    // Dart-Tastatur, Tracker). Der alte Ziffernblock liefert nur die
    // Summe - dort bleibt es bei der bisherigen, ungeprueften Zaehlung.
    const wurfListe =
      Array.isArray(optionen.darts) && optionen.darts.length
        ? optionen.darts
        : null;

    // ── Double-In (29.08.2026): Zaehlen beginnt erst mit einem Doppel ──
    if (isLocal501 && doubleIn501 && wurfListe) {
      const schonDrin =
        werferNummer === 1 ? p1Eingecheckt501 : p2Eingecheckt501;
      if (!schonDrin) {
        let zaehlt = 0;
        let drin = false;
        for (const d of wurfListe) {
          if (!drin && istDoppelDart501(d)) drin = true;
          if (drin) zaehlt += dartPunkte501(d);
        }
        if (drin) {
          if (werferNummer === 1) p1Eingecheckt501 = true;
          else p2Eingecheckt501 = true;
        }
        if (zaehlt < score) {
          showToast(
            tf("js.g501.doubleInOffen", { p1: werferName, p2: score - zaehlt }),
            "warning",
          );
          score = zaehlt;
        }
      }
    }

    const finishRegel = geltendeFinishRegel501();
    let newScore = currentPoints - score;
    let isBust = false;
    let throwText = score.toString();

    // Rest 1 ist nur bei Straight-Out weiter spielbar.
    if (newScore < 0 || (newScore === 1 && finishRegel !== "straight")) {
      newScore = currentPoints;
      isBust = true;
      // Alpha-Wunsch 13.08.2026: Der geworfene Score bleibt sichtbar -
      // "Bust (45)" statt nur "Bust". Der Text wandert unveraendert durch
      // History, DB-Sync und Wurfliste; gefaerbt wird an der Anzeige
      // (faerbeLastThrow), nicht am Text.
      throwText = tf("js.g501.038", { p1: score });
    }

    // Pro-Dart-Wertung (13.08.2026): Das Auto-Scoring kennt den LETZTEN
    // Dart und meldet einen Bust, den die Summe allein nicht verraet -
    // exakt 0 erreicht, aber nicht mit Doppel oder Bullseye beendet.
    // Fuer Ziffernblock/Rechner aendert sich nichts (optionen bleibt leer);
    // dort ist der letzte Dart unbekannt, 0 zaehlt weiter als Finish.
    if (optionen.erzwungenerBust && !isBust) {
      newScore = currentPoints;
      isBust = true;
      throwText = tf("js.g501.038", { p1: score });
    }

    // ── Finish-Regel (29.08.2026): der letzte Dart entscheidet ─────────
    // Gilt fuer JEDEN Eingabeweg, der die Dartliste kennt - vorher wurde
    // ein Finish auf S20 statt D10 bei Board/Tastatur als Game Shot
    // gewertet (Produkttest, kritisch).
    if (!isBust && newScore === 0 && wurfListe) {
      const letzter = wurfListe[wurfListe.length - 1];
      const gueltig =
        finishRegel === "straight" ||
        istDoppelDart501(letzter) ||
        (finishRegel === "master" && istTripleDart501(letzter));
      if (!gueltig) {
        newScore = currentPoints;
        isBust = true;
        throwText = tf("js.g501.038", { p1: score });
      }
    }

    let isFinished = newScore === 0;

    // --- PRO STATS ---
    // Echte Dartzahl (29.08.2026): Board, Dart-Tastatur und Tracker
    // liefern die Einzeldarts - vorher zaehlte jede Aufnahme pauschal 3,
    // ein 2-Dart-Finish verschlechterte den Average und ein 8-Dart-Leg
    // war statistisch unmoeglich (Produkttest, kritisch). Nur der alte
    // Ziffernblock (nackte Summe) bleibt bei 3.
    let dartsThrownThisTurn = wurfListe ? wurfListe.length : 3;
    let doubleDarts = 0;
    let pStats = isLocal501
      ? localCurrentTurn === 1
        ? statsTracker.p1
        : statsTracker.p2
      : amIPlayer1
      ? statsTracker.p1
      : statsTracker.p2;

    // Schutz an der Verwendungsstelle (13.08.2026): pStats kann aus dem
    // Ur-Zustand (app.js) oder einem alten DB-Snapshot stammen - dann
    // fehlen neuere Felder und die Inkremente unten wuerden crashen
    // (scoreFrequencies) oder still NaN produzieren (first9*).
    ergaenzeStatsFelder(pStats);

    let statsSnapshot = JSON.parse(JSON.stringify(statsTracker));
    // 2. WENN WIR HIER SIND: DER WURF IST GÜLTIG & BESTÄTIGT! JETZT STATS SPEICHERN!
    if (score === 180) pStats.t180++;
    else if (score >= 140) pStats.t140++;
    else if (score >= 100) pStats.t100++;

    let thrownVal = isBust ? 0 : score;
    if (thrownVal > 0) {
      pStats.scoreFrequencies[thrownVal] =
        (pStats.scoreFrequencies[thrownVal] || 0) + 1;
    }

    // Checkout-Versuche (29.08.2026): Mit Einzeldarts sind die Darts aufs
    // Doppel zaehlbar - ein Versuch ist jeder Dart bei einem Doppel-Rest
    // (50 oder gerade <= 40). Ohne Dartliste bleibt der Zaehler wie
    // bisher stehen (keine geratenen Quoten).
    if (wurfListe && finishRegel !== "straight") {
      let laufenderRest = currentPoints;
      for (const d of wurfListe) {
        if (
          laufenderRest === 50 ||
          (laufenderRest >= 2 && laufenderRest <= 40 && laufenderRest % 2 === 0)
        ) {
          doubleDarts++;
        }
        laufenderRest -= dartPunkte501(d);
      }
      pStats.checkoutAttempts += doubleDarts;
    }

    if (isBust) {
      pStats.busts++;
    } else if (isFinished) {
      pStats.checkoutHits++;
      if (currentPoints > (pStats.highestFinish || 0)) {
        pStats.highestFinish = currentPoints;
      }
    }

    let dartsBeforeTurn = pStats.dartsCurrentLeg;
    if (dartsBeforeTurn < 9) {
      // Errechnet, wie viele Darts DIESER Aufnahme noch zu den ersten 9 gehören
      let allowedDarts = Math.min(dartsThrownThisTurn, 9 - dartsBeforeTurn);
      pStats.first9Darts += allowedDarts;

      // Fällt die komplette Aufnahme in die ersten 9 Darts?
      if (allowedDarts === dartsThrownThisTurn) {
        pStats.first9Score += thrownVal;
      } else {
        // Falls die Aufnahme die Grenze überschreitet (z.B. Darts 8, 9, 10 der Runde)
        // -> Rechnen wir den Score anteilig runter, da wir Einzeldarts nicht kennen.
        pStats.first9Score += Math.round(
          (thrownVal / dartsThrownThisTurn) * allowedDarts
        );
      }
    }

    pStats.dartsCurrentLeg += dartsThrownThisTurn;
    // Bestes Leg nur, wenn die Dartzahl fuer diese Startpunktzahl
    // PHYSISCH moeglich ist (je Dart max 60, der letzte max Bullseye 50):
    // 501 braucht mindestens 9 Darts. Befund 14.08.2026: Nach einem
    // abgebrochenen Leg konnte dartsCurrentLeg beim naechsten echten
    // Finish einen Rumpfwert tragen (z. B. 3) - der landete als
    // "Bestes Leg" dauerhaft in stats_501 und ist von dort nicht mehr
    // von einem echten Wert zu unterscheiden. Die Untergrenze schneidet
    // genau diese unmoeglichen Werte ab, ohne kurze Varianten (z. B.
    // Start 170 -> 3 Darts moeglich) zu verlieren.
    if (
      isFinished &&
      pStats.dartsCurrentLeg >= mindestDarts501(startingScore501) &&
      (pStats.bestLeg === 0 || pStats.dartsCurrentLeg < pStats.bestLeg)
    ) {
      pStats.bestLeg = pStats.dartsCurrentLeg;
    }
    // -------------------------------------

    if (isLocal501) {
      history501Stack.push({
        p1Score: localP1Score,
        p2Score: localP2Score,
        p1Darts: p1Darts501,
        p2Darts: p2Darts501,
        turn: localCurrentTurn,
        p1Last: p1LastThrow,
        p2Last: p2LastThrow,
        p1Total: p1TotalScore,
        p2Total: p2TotalScore,
        p1Throws: [...p1LegThrows], // <--- NEU
        p2Throws: [...p2LegThrows], // <--- NEU
        statsTrackerState: statsSnapshot,
      });

      // --- NEU: WURF IN DIE LISTE SCHREIBEN (LOKAL) ---
      if (localCurrentTurn === 1)
        p1LegThrows.push({
          old: currentPoints,
          thrown: throwText,
          new: newScore,
        });
      else
        p2LegThrows.push({
          old: currentPoints,
          thrown: throwText,
          new: newScore,
        });
      updateThrowHistoryUI();
      // ------------------------------------------------

      if (localCurrentTurn === 1) {
        localP1Score = newScore;
        p1Darts501 += dartsThrownThisTurn; // Nutzt jetzt die echten Darts!
        p1TotalScore += currentPoints - newScore;
        p1LastThrow = throwText;
      } else {
        localP2Score = newScore;
        p2Darts501 += dartsThrownThisTurn; // Nutzt jetzt die echten Darts!
        p2TotalScore += currentPoints - newScore;
        p2LastThrow = throwText;
      }
      update501QoL(localP1Score, localP2Score);

      if (isFinished) {
        // VOR handleLegWinLocal melden: Das Ueberblendfenster setzt dort
        // den Siegertext, den caller.js beobachtet. Erst "Game shot",
        // dann "Match fuer X" - andersherum stuende die Reihenfolge kopf.
        melde501Wurf({
          score,
          rest: newScore,
          bust: isBust,
          finish: true,
          spieler: werferName,
          nummer: werferNummer,
        });
        handleLegWinLocal(
          localCurrentTurn === 1 ? localP1Name : localP2Name,
          localCurrentTurn === 1 ? 1 : 2,
          score
        );
        return true; // Leg gewonnen ist ein gewerteter Wurf, kein Ausstieg
      }
      localCurrentTurn = localCurrentTurn === 1 ? 2 : 1;
      updateLocalTurnHighlight();
      if (localCurrentTurn === 2 && isP2Bot) play501BotTurn();
    } else {
      let prevState = {
        player1_score: getOnlineScore(1),
        player2_score: getOnlineScore(2),
        player1_darts: p1Darts501,
        player2_darts: p2Darts501,
        player1_avg:
          parseFloat(document.getElementById("p1-match-avg").innerText) || 0,
        player2_avg:
          parseFloat(document.getElementById("p2-match-avg").innerText) || 0,
        player1_last_score: document.getElementById("p1-last-throw").innerText,
        player2_last_score: document.getElementById("p2-last-throw").innerText,
        current_turn: amIPlayer1 ? 1 : 2,
      };

      if (amIPlayer1) {
        p1LegThrows.push({
          old: currentPoints,
          thrown: throwText,
          new: newScore,
        });
        p1Darts501 += dartsThrownThisTurn;
        p1TotalScore += currentPoints - newScore;
      } else {
        p2LegThrows.push({
          old: currentPoints,
          thrown: throwText,
          new: newScore,
        }); // <--- NEU
        p2Darts501 += dartsThrownThisTurn;
        p2TotalScore += currentPoints - newScore;
      }
      let myDarts = amIPlayer1 ? p1Darts501 : p2Darts501;

      update501QoL(
        amIPlayer1 ? newScore : prevState.player1_score,
        amIPlayer1 ? prevState.player2_score : newScore
      );
      isMyTurn = false;
      document.getElementById("input-display-501").innerText = t("js.g501.033");

      prevState.statsTrackerState = statsSnapshot;

      let updatePayload = {
        current_turn: amIPlayer1 ? 2 : 1,
        last_action: isBust ? t("js.g121.006") : tf("js.g501.039", { p1: score }),
        undo_requested: false,
        prev_state: prevState,
      };

      if (amIPlayer1) {
        updatePayload.player1_score = newScore;
        updatePayload.player1_darts = myDarts;
        updatePayload.player1_last_score = throwText;
        updatePayload.player1_avg =
          parseFloat(((p1TotalScore / myDarts) * 3).toFixed(2)) || 0.0;
      } else {
        updatePayload.player2_score = newScore;
        updatePayload.player2_darts = myDarts;
        updatePayload.player2_last_score = throwText;
        updatePayload.player2_avg =
          parseFloat(((p2TotalScore / myDarts) * 3).toFixed(2)) || 0.0;
      }

      if (isFinished) {
        let p1LegsDB = getOnlineLegs(1);
        let p2LegsDB = getOnlineLegs(2);
        if (amIPlayer1) p1LegsDB++;
        else p2LegsDB++;
        updatePayload.player1_legs = p1LegsDB;
        updatePayload.player2_legs = p2LegsDB;

        let safeBestOf = parseInt(bestOfLegs) || 3;
        let neededLegs = Math.max(1, Math.ceil(safeBestOf / 2));
        if (p1LegsDB >= neededLegs || p2LegsDB >= neededLegs)
          updatePayload.status = "match_won";
        else updatePayload.status = "leg_won";
      }
      const { error: dbError } = await _supabase
        .from("live_matches")
        .update(updatePayload)
        .eq("room_code", currentRoomCode);
      if (dbError) {
        showToast(t("js.g501.009") + dbError.message, "error");
        document.getElementById("input-display-501").innerText = t("js.g501.010");
        return false;
      }
    }

    melde501Wurf({
      score,
      rest: newScore,
      bust: isBust,
      finish: isFinished,
      spieler: werferName,
      nummer: werferNummer,
    });
    return true;
  } catch (err) {
    // Ohne catch scheitern Fehler hier stumm und der Wurf bleibt haengen.
    console.error(t("js.g501.011"), err);
    showToast(t("js.g501.012"), "error");
    current501Input = "";
    update501Display();
    return false;
  } finally {
    isSubmittingThrow = false;
  }
}

// ------------------------------------------------------------------
// WURFMELDUNG NACH AUSSEN (14.08.2026)
//
// Ein Ereignis je GEWERTETEM Wurf - gemeldet an den beiden Stellen, an
// denen submit501Score mit Erfolg zurueckkehrt. Abnehmer ist heute
// caller.js (Sprachansage); weitere koennen sich anhaengen, ohne dass
// die Spiellogik davon wissen muss.
//
// WARUM EIN EREIGNIS UND KEINE DOM-BEOBACHTUNG: Wirft jemand zweimal
// hintereinander dieselbe Zahl (26, 26 - Alltag im Darts), aendert sich
// der Text im Anzeigefeld nicht, und ein MutationObserver bliebe stumm.
// Der zweite Wurf ginge verloren.
//
// Ein Fehler beim Abnehmer darf den Wurf nie kosten - deshalb das try.
// ------------------------------------------------------------------
function melde501Wurf(detail) {
  try {
    window.dispatchEvent(
      new CustomEvent("secure-darts:wurf", {
        detail: { ...detail, anwurf: naechsterAnwurf501(detail) },
      }),
    );
  } catch (error) {
    /* CustomEvent fehlt nur in sehr alten Umgebungen */
  }
}

/** Wer wirft als NAECHSTES, und auf welchem Rest steht er?
 *
 * ALPHA-BEFUND 15.08.2026: Der Caller sagte "You require" am Ende der
 * Aufnahme und meinte den Rest dessen, der GERADE geworfen hatte - und
 * verschluckte dafuer den Score. Ein Schiedsrichter macht beides und in
 * dieser Reihenfolge: Score des Wurfs, dann der Verbleib fuer den, der
 * jetzt an die Oche tritt.
 *
 * Warum die Auskunft an der Wurfmeldung haengt und kein eigenes Ereignis
 * ist: Eine Aufnahme folgt immer auf die vorige, und beides in EINER
 * Ansage laesst caller.js die Tonfolge nahtlos planen. Zwei Ereignisse
 * waeren zwei Ansagen, und die zweite schnitte die erste ab.
 * (Legbeginn braucht keine: Bei 501 gibt es nichts anzusagen.)
 *
 * Der Sonderfall ist der Gegnerwurf online: sync501UI meldet ihn, BEVOR
 * isMyTurn und die Punktefelder umgestellt sind - aktuellerWerfer501()
 * naennte dort noch den Gegner. Nach einem Gegnerwurf ist aber immer der
 * eigene Zug, und der eigene Rest hat sich durch dessen Wurf nicht
 * geaendert. Deshalb dort direkt statt ueber die Zugauskunft. */
function naechsterAnwurf501(detail) {
  try {
    if (detail?.finish) return null; // Leg vorbei, es tritt niemand an
    if (detail?.gegner) {
      const n = amIPlayer1 ? 1 : 2;
      return { nummer: n, rest: getOnlineScore(n) };
    }
    const werfer = aktuellerWerfer501();
    return werfer ? { nummer: werfer.nummer, rest: werfer.rest } : null;
  } catch (error) {
    return null;
  }
}

/** Wurf des GEGNERS melden (nur online).
 *
 * submit501Score laeuft beim Werfenden - der Wurf des Gegners erreicht
 * uns ausschliesslich ueber den Realtime-Abgleich. Ohne diese Meldung
 * saehe ein Streamer die Zahl des Gegners, hoerte sie aber nie.
 *
 * Die Bedingung am Aufrufort (Dartzahl des Gegners GESTIEGEN) trifft je
 * Wurf genau einmal zu: Direkt darunter werden p1Darts501/p2Darts501 auf
 * den neuen Stand gesetzt. Ein wiederholter Abgleich derselben Zeile
 * meldet deshalb nichts doppelt.
 *
 * `text` ist die gespeicherte Wurfanzeige - eine Zahl ("60") oder
 * "Bust (45)". Beides wird hier zerlegt, damit die Ansage denselben
 * Unterschied kennt wie die eigene Seite. */
function meldeGegnerWurf501(nummer, text, neuerRest) {
  const roh = String(text ?? "");
  if (!roh || roh === "-") return;
  const bust = /bust/i.test(roh);
  const zahl = parseInt(roh.replace(/[^0-9]/g, ""), 10);
  melde501Wurf({
    score: Number.isFinite(zahl) ? zahl : 0,
    rest: Number(neuerRest),
    bust,
    finish: Number(neuerRest) === 0,
    spieler: document.getElementById(`p${nummer}-name`)?.innerText || "",
    nummer,
    gegner: true,
  });
}

/** Wer ist JETZT am Wurf, und auf welchem Rest steht er?
 *
 * Auskunft ueber vorhandenen Zustand, kein zweiter Spielstand: obs.js
 * entscheidet damit, welchen Boardbereich es zoomen soll (das Doppel des
 * Spielers an der Oche, nicht das des Zuschauers am Tisch). null, wenn
 * gerade kein 501 laeuft. */
function aktuellerWerfer501() {
  try {
    const screen = document.getElementById("game-501-screen");
    if (!screen || screen.style.display === "none") return null;
    if (isLocal501) {
      const n = localCurrentTurn === 1 ? 1 : 2;
      return {
        nummer: n,
        name: n === 1 ? localP1Name : localP2Name,
        rest: n === 1 ? localP1Score : localP2Score,
      };
    }
    const ich = amIPlayer1 ? 1 : 2;
    const n = isMyTurn ? ich : ich === 1 ? 2 : 1;
    return {
      nummer: n,
      name: document.getElementById(`p${n}-name`)?.innerText || "",
      rest: getOnlineScore(n),
    };
  } catch (error) {
    return null;
  }
}

/** Rest des Spielers, der an DIESEM Board wirft - fuer den OBS-Zoom.
 *
 * Die Kamera zeigt genau eine Scheibe: die hier stehende. Online wirft der
 * Gegner auf SEIN Board; auf sein Doppel zu zoomen zeigt dem Zuschauer eine
 * leere Scheibe, waehrend anderswo gespielt wird. Deshalb:
 *
 *   online           -> immer der eigene Rest, egal wer gerade dran ist
 *   lokal gegen Bot  -> Spieler 1 (der Bot wirft nicht)
 *   lokal zu zweit   -> der Spieler an der Oche (beide werfen auf DIESES
 *                       Board, hier ist der Gegner also sehr wohl im Bild)
 *
 * null, wenn gerade kein 501 laeuft. Unterschied zu aktuellerWerfer501():
 * das ist die Auskunft "wer ist dran", dies hier "wessen Doppel steht vor
 * dieser Kamera" - online faellt beides auseinander. */
function eigenerRest501() {
  try {
    const screen = document.getElementById("game-501-screen");
    if (!screen || screen.style.display === "none") return null;
    const fest = isLocal501
      ? (isP2Bot ? 1 : localCurrentTurn === 2 ? 2 : 1) === 1
        ? localP1Score
        : localP2Score
      : getOnlineScore(amIPlayer1 ? 1 : 2);
    if (!Number.isFinite(Number(fest))) return null;
    // BEFUND 15.08.2026 (Alpha): Der Zoom kam eine Aufnahme zu spaet.
    // 161 Rest, T20 + T17 -> es bleiben 50, also das Bullseye. Der Rest im
    // Spielstand steht aber bis zum Bestaetigen auf 161, und OBS sah
    // deshalb kein Ziel; gezoomt wurde erst, wenn der Spieler die Pfeile
    // schon holt. Deshalb hier der LIVE-Rest: gewerteter Stand minus die
    // Darts, die in dieser Aufnahme schon liegen.
    return Number(fest) - offeneAufnahme501();
  } catch (error) {
    return null;
  }
}

/** Punkte der laufenden, noch nicht gewerteten Aufnahme.
 *
 * Es gibt vier Eingabewege, und jeder haelt seine Darts woanders. Gezaehlt
 * werden die drei, die DART FUER DART arbeiten:
 *
 *   Tracker   autoScore.state.darts    erkannte/korrigierte Einzeldarts
 *   Board     boardOffeneSumme501()    angetippte Einzeldarts
 *   Rechner   calcDarts                eingegebene Einzeldarts
 *
 * Der ZIFFERNBLOCK bleibt bewusst draussen: Dort tippt jemand eine Summe,
 * und eine halb getippte Zahl ist kein geworfener Dart - bei "60" stuende
 * nach der ersten Ziffer ein Rest, den niemand geworfen hat.
 *
 * Die Puffer sind nie gleichzeitig gefuellt (jeder wird beim Uebernehmen
 * und beim Zugwechsel geleert); addiert wird trotzdem statt ausgewaehlt,
 * weil eine Summe keinen fuenften Fall kennt, den jemand vergisst.
 *
 * Botdarts zaehlen NICHT mit - sie liegen in board-input.js daneben
 * (zustand.fremde) und gehoeren nicht zum Rest des Spielers vor der
 * Kamera. */
function offeneAufnahme501() {
  let summe = 0;
  try {
    const board = window.boardOffeneSumme501?.();
    if (Number.isFinite(board)) summe += board;
  } catch (error) {
    /* Auskunft fuer die Anzeige, nie spielentscheidend */
  }
  try {
    const darts = window.autoScore?.state?.darts;
    if (Array.isArray(darts)) {
      summe += darts.reduce((a, d) => a + (Number(d?.points) || 0), 0);
    }
  } catch (error) {
    /* dito */
  }
  try {
    if (Array.isArray(calcDarts)) {
      summe += calcDarts.reduce((a, d) => a + (Number(d?.val) || 0), 0);
    }
  } catch (error) {
    /* dito */
  }
  return summe;
}

// ------------------------------------------------------------------
// PRO-DART-WERTUNG fuer das Auto-Scoring (13.08.2026, Alpha-Wunschliste)
//
// autoscore.js meldet jeden erkannten (oder korrigierten) Dart sofort
// hierher. Diese Funktion zieht den Rest LIVE in der Anzeige ab und
// entscheidet, ob die Aufnahme vorzeitig endet:
//
//   * Rest < 0 oder Rest = 1            -> Bust, Zug sofort vorbei
//   * Rest = 0 mit Doppel/Bullseye      -> Finish, sofort uebernehmen
//   * Rest = 0 OHNE Doppel              -> Bust (das kann die reine
//     Summenpruefung in submit501Score nicht sehen - dafuer traegt der
//     Dart base/mult, und submit bekommt erzwungenerBust)
//
// GEWERTET wird weiterhin ausschliesslich in submit501Score, und in die
// Datenbank geht weiterhin die Aufnahme-Summe (Entscheidung 13.08.2026:
// Anzeige pro Dart, DB pro Aufnahme - keine 3-fache Schreiblast im
// Free-Tier). Der Gegner sieht den Abzug am Ende der Aufnahme.
// ------------------------------------------------------------------
// "Letzter Wurf"-Anzeige setzen und einfaerben (Alpha-Wunsch 13.08.2026):
// Ein Bust soll sofort ins Auge springen - der Text traegt den geworfenen
// Score ("Bust (45)"), die Farbe kommt hier zentral dazu. Alle Schreiber
// (lokal wie Online-Sync) laufen ueber diese eine Stelle.
function faerbeLastThrow(id, text) {
  const el = document.getElementById(id);
  if (!el) return;
  el.innerText = text;
  el.style.color = String(text).startsWith(t("js.g121.006"))
    ? "var(--accent-red)"
    : "";
}

function autoscore501Dart(dart, summeAufnahme) {
  if (!isLocal501 && !isMyTurn) return null;

  const start = isLocal501
    ? localCurrentTurn === 1
      ? localP1Score
      : localP2Score
    : getOnlineScore(amIPlayer1 ? 1 : 2);
  const rest = start - summeAufnahme;

  // Live-Anzeige: das grosse Restfeld des Werfers. Die Seitenpanels
  // spiegeln automatisch mit (board-input.js, spiegelRest). Bei Bust
  // nichts anzeigen - submit501Score stellt den alten Rest gleich wieder
  // her, ein kurz aufblitzender Minuswert waere nur verwirrend.
  if (rest >= 0 && rest !== 1) {
    const werferIstP1 = isLocal501 ? localCurrentTurn === 1 : amIPlayer1;
    const feld = document.getElementById(werferIstP1 ? "p1-score" : "p2-score");
    if (feld) feld.innerText = rest;
  }

  // Double-In (29.08.2026): Solange der Werfer nicht eingecheckt ist,
  // zaehlen seine Darts womoeglich nicht - dann kein vorzeitiges Urteil,
  // die Aufnahme wird beim Ziehen regulaer verrechnet.
  if (isLocal501 && doubleIn501) {
    const eingecheckt =
      localCurrentTurn === 1 ? p1Eingecheckt501 : p2Eingecheckt501;
    if (!eingecheckt) return null;
  }

  const regel = geltendeFinishRegel501();
  if (rest < 0 || (rest === 1 && regel !== "straight")) {
    return { abschliessen: true, bust: true };
  }
  if (rest === 0) {
    if (regel === "straight") return { abschliessen: true, bust: false };
    const gueltig =
      istDoppelDart501(dart) || (regel === "master" && istTripleDart501(dart));
    return { abschliessen: true, bust: !gueltig };
  }
  return null;
}

function listenForOpponent(roomCode) {
  if (realtimeSubscription) _supabase.removeChannel(realtimeSubscription);

  // Eindeutiger Channel pro Raum für bessere Stabilität
  realtimeSubscription = _supabase
    .channel(`room-${roomCode}`)
    .on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "live_matches",
        filter: `room_code=eq.${roomCode}`,
      },
      (payload) => {
        const dbData = payload.new;
        if (!dbData) return;

        // --- Abbruch-Check (Status-basiert) ---
        if (dbData.status === "cancelled") {
          let cancelerName = dbData.last_action || t("js.g501.013");
          if (cancelerName !== myOnlineName) {
            showToast(tf("js.g501.022", { p1: cancelerName }), "info");
          }
          // Wichtig: Wir rufen hier die UI-Löschung auf
          cancelCurrentGame("game-501-screen", true);
          return;
        }

        // --- Lobby Update ---
        if (dbData.status === "waiting") {
          if (typeof updateLobbyPlayers === "function") {
            updateLobbyPlayers(dbData.player1_name, dbData.player2_name);
          }
        }

        // --- Spielstart ---
        if (
          dbData.status === "playing" &&
          document.getElementById("game-501-screen").style.display === "none"
        ) {
          document.getElementById("online-lobby-screen").style.display = "none";
          let activeLobby = document.getElementById("lobby-active");
          if (activeLobby) activeLobby.style.display = "none";
          document.getElementById("game-501-screen").style.display = "block";
          starteOnlineBullOff(dbData);
        }

        if (dbData.status === "playing") sync501UI(dbData);

        // --- Sieg-Logik (Leg/Match) ---
        if (dbData.status === "leg_won" || dbData.status === "match_won") {
          sync501UI(dbData); // Zwingt die UI, die 0 beim Gegner anzuzeigen!

          let p1WonLeg = dbData.player1_score === 0;
          let winnerName = p1WonLeg ? dbData.player1_name : dbData.player2_name;
          let isMatchWon = dbData.status === "match_won";

          const overlay = document.getElementById("win-overlay-501");
          const btnNext = document.getElementById("btn-next-leg");
          const btnRematch = document.getElementById("btn-rematch");

          document.getElementById("win-subtitle-501").innerText = isMatchWon
            ? tf("js.g501.023", { p1: winnerName })
            : tf("js.g501.024", { p1: winnerName });

          // 1. ZUERST DAS LEG AUFZEICHNEN (Fehlerbehebung: Muss vor dem Speichern passieren!)
          if (overlay.style.display !== "flex") {
            let finishPoints =
              parseInt((dbData.last_action || "0").replace(/\D/g, "")) || 0;
            recordLegStat501(
              winnerName,
              dbData.player1_name,
              dbData.player2_name,
              dbData.player1_score,
              dbData.player2_score,
              finishPoints
            );
          }

          if (isMatchWon) {
            btnNext.style.display = "none";

            // Nur der Host darf das Rematch triggern
            if (isOnlineHost) {
              btnRematch.style.display = "inline-block";
            } else {
              btnRematch.style.display = "none";
              document.getElementById("win-subtitle-501").innerText +=
                t("js.g501.014");
            }

            // 2. DANN ERST DIE STATS IN DIE DB SCHREIBEN (Jetzt ist das Match-Log vollständig)
            if (overlay.style.display !== "flex" && !isGuest && currentUser) {
              let totalLegs = dbData.player1_legs + dbData.player2_legs;
              let myLegs = amIPlayer1
                ? dbData.player1_legs
                : dbData.player2_legs;
              let myScore = amIPlayer1 ? p1TotalScore : p2TotalScore;
              let myDarts = amIPlayer1
                ? dbData.player1_darts
                : dbData.player2_darts;

              let myAvg =
                myDarts > 0 ? ((myScore / myDarts) * 3).toFixed(2) : 0;
              let isWin =
                (amIPlayer1 && p1WonLeg) || (!amIPlayer1 && !p1WonLeg);

              let myStatsObj = amIPlayer1 ? statsTracker.p1 : statsTracker.p2;
              let finalScore = myStatsObj.highestFinish || 0;

              const opponentName = amIPlayer1
                ? dbData.player2_name
                : dbData.player1_name;

              const matchPayload = {
                mode: "501",
                players: [
                  {
                    user_id: currentUser.id,
                    opponentName,
                    isWin,
                    legsWon: myLegs,
                    totalLegs,
                    dartsThrown: myDarts,
                    scoreThrown: myScore,
                    matchAvg: parseFloat(myAvg),
                    highestFinish: finalScore,
                    statsObj: myStatsObj,
                    matchLog: currentMatchLog501, // <-- Jetzt sind hier auch beide Legs drin!
                  },
                ],
              };

              _supabase
                .rpc("process_match_results", { payload: matchPayload })
                .then(({ error }) => {
                  if (error) {
                    console.error("Stats Error:", error.message);
                    if (typeof showToast === "function")
                      showToast(
                        t("js.g501.015"),
                        "error"
                      );
                  } else {
                    if (typeof showToast === "function")
                      showToast(t("js.g501.034"), "success");
                  }
                });
            }
          } else {
            btnRematch.style.display = "none";

            // Automatischer Start durch den Host
            if (isOnlineHost) {
              btnNext.style.display = "inline-block";
              btnNext.innerText = t("js.g501.016");
              btnNext.disabled = false;

              setTimeout(() => {
                if (overlay.style.display === "flex") {
                  startNextLeg();
                }
              }, 3000);
            } else {
              btnNext.style.display = "inline-block";
              btnNext.innerText = t("js.g501.016");
              btnNext.disabled = true;
            }
          }

          overlay.style.display = "flex";
        }

        // Reset bei neuem Leg / Rematch
        if (
          dbData.status === "playing" &&
          document.getElementById("win-overlay-501").style.display === "flex"
        ) {
          document.getElementById("win-overlay-501").style.display = "none";
          if (dbData.player1_legs === 0 && dbData.player2_legs === 0) {
            resetStatsTracker();
            p1TotalScore = 0;
            p2TotalScore = 0;
            currentMatchLog501 = [];
          }

          // ---> NEU: Darts-Counter für das neue Leg zwingend nullen! (Online Bug Fix)
          statsTracker.p1.dartsCurrentLeg = 0;
          statsTracker.p2.dartsCurrentLeg = 0;

          p1DartsAtLegStart = dbData.player1_darts;
          p2DartsAtLegStart = dbData.player2_darts;
          p1LegThrows = [];
          p2LegThrows = [];

          sync501UI(dbData);
        }
      }
    )
    // Bull-Off (15.08.2026) laeuft ueber BROADCAST, nicht ueber die Tabelle.
    //
    // Die Auslosung ist fluechtig: Sie interessiert nur die zwei Geraete, die
    // gerade davorstehen, und nur fuer ein paar Sekunden. Sie in live_matches
    // zu schreiben haette eine Migration gekostet (die Tabelle haette zwei
    // Spalten mehr, die nach zehn Sekunden nie wieder jemand liest) - und der
    // Kanal steht ohnehin schon.
    //
    // Uebertragen wird NUR der Abstand in Millimetern. Beide Seiten rechnen
    // dann aus denselben zwei Zahlen dasselbe Ergebnis aus; niemand muss dem
    // anderen glauben, und der genaue Einschlag bleibt privat.
    .on("broadcast", { event: "bulloff" }, ({ payload }) => {
      if (!payload || !bullOff501?.offen?.()) return;
      // Der eigene Wurf kommt nicht zurueck (self: false) - aber falls doch,
      // wuerde er hier den Gegnerplatz ueberschreiben.
      if (payload.p1 === amIPlayer1) return;
      bullOff501.fremderWurf(amIPlayer1 ? 1 : 0, payload.mm);
    })
    .on(
      "postgres_changes",
      {
        event: "DELETE",
        schema: "public",
        table: "live_matches",
        filter: `room_code=eq.${roomCode}`,
        // HINWEIS: Dieser Filter funktioniert oft nur, wenn room_code der PK ist!
      },
      (payload) => {
        // Wenn die Zeile weg ist, gehen wir sicherheitshalber immer raus

        if (
          payload.old &&
          payload.old.room_code &&
          payload.old.room_code !== roomCode
        ) {
          return;
        }
        showToast(t("js.g501.029"));
        cancelCurrentGame("game-501-screen", true);
      }
    )
    .subscribe();
}

async function cancel501Game(skipConfirm = false) {
  const roomToDelete = currentRoomCode;

  const execute = async () => {
    if (!isLocal501 && roomToDelete) {
      // 1. Status auf "cancelled" setzen (Benachrichtigt den Gegner via UPDATE)
      await _supabase
        .from("live_matches")
        .update({
          status: "cancelled",
          last_action: myOnlineName,
        })
        .eq("room_code", roomToDelete);

      // 2. Kurz warten und dann erst ganz löschen
      setTimeout(async () => {
        await _supabase
          .from("live_matches")
          .delete()
          .eq("room_code", roomToDelete);
      }, 1000);
    }
    cancelCurrentGame("game-501-screen", true);
  };

  if (skipConfirm) await execute();
  else showCancelModal(execute);
}

async function requestUndo() {
  if (isLocal501) {
    undo501Turn();
  } else {
    // 1. Aktuellen Status aus der Datenbank abrufen
    let { data: room } = await _supabase
      .from("live_matches")
      .select("prev_state")
      .eq("room_code", currentRoomCode)
      .single();

    if (room && room.prev_state) {
      // 2. Sicherheits-Check: Dürfen wir stornieren? (Nur wenn WIR den letzten Wurf gemacht haben)
      let wasMyTurn =
        (amIPlayer1 && room.prev_state.current_turn === 1) ||
        (!amIPlayer1 && room.prev_state.current_turn === 2);

      if (wasMyTurn) {
        let restore = room.prev_state;

        // ---> NEU: STATS TRACKER WIEDERHERSTELLEN <---
        if (restore.statsTrackerState) {
          statsTracker = restore.statsTrackerState; // Überschreibt die falschen Stats mit dem sauberen Snapshot
          delete restore.statsTrackerState; // WICHTIG: Verhindert einen Supabase-Crash beim Update!
        }
        // ---------------------------------------------

        // 3. Zustand sofort wiederherstellen
        restore.undo_requested = false;
        restore.prev_state = null; // Verhindert doppeltes Undo in Folge

        await _supabase
          .from("live_matches")
          .update(restore)
          .eq("room_code", currentRoomCode);
        return;
      }
    }
    // Falls der Gegner in der Zwischenzeit schon geworfen hat:
    showToast(
      t("js.g501.017"),
      "warning",
    );
  }
}

function recordLegStat501(
  winnerName,
  p1Name,
  p2Name,
  p1Rest,
  p2Rest,
  finishScore
) {
  let p1LegDarts = p1Darts501 - p1DartsAtLegStart;
  let p2LegDarts = p2Darts501 - p2DartsAtLegStart;

  // NEU: Wir speichern die kompletten Wurflisten für dieses Leg
  let legObj = {
    leg_number: currentMatchLog501.length + 1,
    winner: winnerName,
    p1_name: p1Name,
    p2_name: p2Name,
    p1_darts: p1LegDarts,
    p2_darts: p2LegDarts,
    p1_rest: p1Rest,
    p2_rest: p2Rest,
    checkout: finishScore,
    // Diese Listen enthalten {old, thrown, new} für jeden Wurf
    p1_history: [...p1LegThrows],
    p2_history: [...p2LegThrows],
  };
  currentMatchLog501.push(legObj);

  p1DartsAtLegStart = p1Darts501;
  p2DartsAtLegStart = p2Darts501;
}

function handleLegWinLocal(winnerName, playerNum, finishScore) {
  recordLegStat501(
    winnerName,
    localP1Name,
    localP2Name,
    localP1Score,
    localP2Score,
    finishScore
  );

  if (playerNum === 1) localP1Legs++;
  else localP2Legs++;

  update501QoL(localP1Score, localP2Score);

  let matchWon = false;
  const legsToWin = Math.max(1, Math.ceil((parseInt(bestOfLegs) || 3) / 2));

  if (localP1Legs >= legsToWin || localP2Legs >= legsToWin) {
    matchWon = true;
    let totalLegs = localP1Legs + localP2Legs;

    // --- NEU: Wir bauen den Payload für das Backend! ---
    const matchPayload = {
      mode: "501",
      players: [],
    };

    // Spieler 1 (Host) hinzufügen, wenn er eine ID hat
    if (localP1Id) {
      let p1Avg =
        p1Darts501 > 0 ? ((p1TotalScore / p1Darts501) * 3).toFixed(2) : 0;
      matchPayload.players.push({
        user_id: localP1Id,
        opponentName: localP2Name,
        isWin: localP1Legs >= legsToWin,
        legsWon: localP1Legs,
        totalLegs: totalLegs,
        dartsThrown: p1Darts501,
        scoreThrown: p1TotalScore,
        matchAvg: parseFloat(p1Avg),
        highestFinish: statsTracker.p1.highestFinish || 0,
        statsObj: statsTracker.p1,
        matchLog: currentMatchLog501,
      });
    }

    // Spieler 2 (Gast) hinzufügen, wenn er sich verifiziert hat UND kein Bot ist
    if (localP2Id && !isP2Bot) {
      let p2Avg =
        p2Darts501 > 0 ? ((p2TotalScore / p2Darts501) * 3).toFixed(2) : 0;
      matchPayload.players.push({
        user_id: localP2Id,
        opponentName: localP1Name,
        isWin: localP2Legs >= legsToWin,
        legsWon: localP2Legs,
        totalLegs: totalLegs,
        dartsThrown: p2Darts501,
        scoreThrown: p2TotalScore,
        matchAvg: parseFloat(p2Avg),
        highestFinish: statsTracker.p2.highestFinish || 0,
        statsObj: statsTracker.p2,
        matchLog: currentMatchLog501,
      });
    }

    console.log("localP1Id", localP1Id, "localP2Id", localP2Id);
    console.log("players payload", matchPayload.players);

    // Payload feuern (Ignoriert lokale Gäste ohne ID komplett)
    if (matchPayload.players.length > 0) {
      _supabase
        .rpc("process_match_results", { payload: matchPayload })
        .then(({ error }) => {
          if (error) console.error("Stats Error:", error.message);
        });
    }
  }

  // Matchende: Warnung entschaerfen - ab hier geht nichts mehr verloren
  // (spielwache.js, 29.08.2026).
  if (matchWon) spielwacheSpielBeendet();

  const overlay = document.getElementById("win-overlay-501");
  document.getElementById("win-subtitle-501").innerText = matchWon
    ? tf("js.g501.023", { p1: winnerName })
    : tf("js.g501.024", { p1: winnerName });

  const btnNext = document.getElementById("btn-next-leg");
  const btnRematch = document.getElementById("btn-rematch");

  if (matchWon) {
    btnNext.style.display = "none";
    btnRematch.style.display = "inline-block";
  } else {
    btnNext.style.display = "inline-block";
    btnRematch.style.display = "none";
    btnNext.innerText = t("js.g501.016");

    // FIX: Der Timer und ein Klick auf den Button koennen sonst beide feuern
    // und resetLegLocal() zweimal ausfuehren -> das frische Leg wird geloescht.
    if (nextLegTimer501) clearTimeout(nextLegTimer501);
    nextLegTimer501 = setTimeout(() => {
      nextLegTimer501 = null;
      if (overlay.style.display === "flex" && isLocal501) {
        startNextLeg();
      }
    }, 1500);
  }
  overlay.style.display = "flex";
}

async function startNextLeg() {
  // FIX: Verhindert, dass Auto-Timer und Button-Klick beide durchlaufen.
  if (nextLegTimer501) {
    clearTimeout(nextLegTimer501);
    nextLegTimer501 = null;
  }
  if (isStartingNextLeg) return;
  isStartingNextLeg = true;
  setTimeout(() => {
    isStartingNextLeg = false;
  }, 300);

  if (isLocal501) {
    resetLegLocal();
  } else if (isOnlineHost) {
    // Nächstes Leg für beide Spieler über die Datenbank einläuten
    let totalLegs = getOnlineLegs(1) + getOnlineLegs(2);
    let starter = (totalLegs + (startspieler501 - 1)) % 2 === 0 ? 1 : 2; // Wer das Leg beginnt, wechselt sich ab (Versatz: Bull-Off)

    await _supabase
      .from("live_matches")
      .update({
        status: "playing",
        player1_score: startingScore501,
        player2_score: startingScore501,
        player1_last_score: "-",
        player2_last_score: "-",
        current_turn: starter,
        last_action: t("js.g501.030"),
        prev_state: null,
      })
      .eq("room_code", currentRoomCode);
  }
}

async function triggerRematch() {
  if (isLocal501) {
    startLocal501Game();
  } else if (isOnlineHost) {
    // Komplettes Spiel resetten über die Datenbank
    await _supabase
      .from("live_matches")
      .update({
        status: "playing",
        player1_score: startingScore501,
        player2_score: startingScore501,
        player1_darts: 0,
        player2_darts: 0,
        player1_legs: 0,
        player2_legs: 0,
        player1_last_score: "-",
        player2_last_score: "-",
        player1_avg: 0,
        player2_avg: 0,
        current_turn: 1,
        last_action: t("js.g501.035"),
        prev_state: null,
      })
      .eq("room_code", currentRoomCode);
  }
}

// --- BOT VARIABLEN ---
let isP2Bot = false;
let botDifficulty501 = 40;
let botDartsThrownThisTurn = 0;
let botDoubleAttempts = 0;
let currentBotAvgSelection = 40;

// Öffnet das neue Menü
function add501Bot() {
  // Vorgabe 45 statt der frueheren 40: Seit es benannte Stufen gibt, soll
  // beim Oeffnen auch eine davon markiert sein - ein Fenster, in dem kein
  // Knopf gilt, sieht aus, als waere die Auswahl kaputt. 45 ist "Freizeit"
  // und liegt dem alten Wert am naechsten.
  currentBotAvgSelection = 45;
  zeichneBotStufen();
  zeigeBotAvg();
  document.getElementById("bot-setup-overlay").style.display = "flex";
  // ui.js setzt den Fokus beim Oeffnen eines Fensters auf das ERSTE
  // bedienbare Element - das waere hier "Anfaenger", waehrend "Freizeit"
  // eingestellt ist. Zwei hervorgehobene Knoepfe, zwei Aussagen. Der Fokus
  // gehoert auf die eingestellte Stufe; von dort tabbt man weiter.
  // Nach dem Beobachter aus ui.js, deshalb setTimeout statt direkt.
  setTimeout(() => {
    document.querySelector("#bot-stufen .bot-stufe.is-aktiv")?.focus();
  }, 0);
}

/** Die benannten Stufen als Schnellwahl in das Bot-Fenster zeichnen.
 *
 *  UMBAU 15.08.2026: Der Regler blieb - er ist genauer als jede Stufe und
 *  wurde nicht schlechter, weil es Stufen gibt. Dazu kommen jetzt dieselben
 *  Namen wie in Secure, aus derselben Liste (bot.js, BOT_STUFEN). Wer
 *  "Profi" antippt, stellt 85 ein; wer 87 will, tippt einmal auf Plus. */
function zeichneBotStufen() {
  const kasten = document.getElementById("bot-stufen");
  if (!kasten || kasten.dataset.gezeichnet) return;
  const stufen = window.BOT_STUFEN || [];
  kasten.innerHTML = "";
  for (const stufe of stufen) {
    const knopf = document.createElement("button");
    knopf.type = "button";
    // BEWUSST OHNE Akzentklasse: `btn-glass accent-*` zeichnet einen
    // farbigen Rahmen, und in diesem engen Raster sahen zwei Knoepfe mit
    // Rahmen aus, als waeren beide gewaehlt. Welche Stufe gilt, sagt hier
    // die gefuellte Flaeche (.is-aktiv) - eine Aussage, ein Merkmal. Die
    // Farbe der Stufe bleibt in BOT_STUFEN und wird in Secure genutzt, wo
    // die Knoepfe untereinander stehen und Platz dafuer ist.
    knopf.className = "btn-glass bot-stufe";
    knopf.dataset.avg = String(stufe.avg);
    knopf.innerHTML =
      `<span>${t("bot.stufe." + stufe.id)}</span><small>Ø ${stufe.avg}</small>`;
    knopf.addEventListener("click", () => setzeBotAvg(stufe.avg));
    kasten.appendChild(knopf);
  }
  kasten.dataset.gezeichnet = "1";
}

/** Anzeige und Stufenmarkierung auf den aktuellen Wert bringen. */
function zeigeBotAvg() {
  const anzeige = document.getElementById("bot-avg-display");
  if (anzeige) anzeige.innerText = currentBotAvgSelection;
  const name = document.getElementById("bot-stufe-name");
  if (name && window.stufeFuerAvg) {
    name.textContent = t("bot.stufe." + window.stufeFuerAvg(currentBotAvgSelection).id);
  }
  document.querySelectorAll("#bot-stufen .bot-stufe").forEach((knopf) => {
    knopf.classList.toggle(
      "is-aktiv",
      Number(knopf.dataset.avg) === currentBotAvgSelection,
    );
  });
}

function setzeBotAvg(avg) {
  currentBotAvgSelection = window.begrenzeAvg
    ? window.begrenzeAvg(avg)
    : Math.min(120, Math.max(20, Number(avg) || 40));
  zeigeBotAvg();
}

// Steuert die Plus/Minus Buttons
function changeBotAvg(delta) {
  setzeBotAvg(currentBotAvgSelection + delta);
}

function cancelBotSetup() {
  document.getElementById("bot-setup-overlay").style.display = "none";
}

function confirmBotSetup() {
  document.getElementById("bot-setup-overlay").style.display = "none";
  localP2Name = tf("js.g501.040", { p1: currentBotAvgSelection });
  document.getElementById("local-p2-name").value = localP2Name;
  isP2Bot = true;
  botDifficulty501 = currentBotAvgSelection;
}

async function play501BotTurn() {
  if (localP2Score <= 0 || !isP2Bot || !isLocal501) return;

  // UI sperren während der Bot wirft
  const numpad = document.querySelector(".numpad-grid");
  const presets = document.querySelector(".preset-grid");
  if (numpad) numpad.style.pointerEvents = "none";
  if (presets) presets.style.pointerEvents = "none";

  // Kurze Denkpause vor dem ersten Dart
  await new Promise((r) => (botTimer501 = setTimeout(r, 600)));
  if (!isLocal501) return; // Falls in der Pause abgebrochen wurde

  botDartsThrownThisTurn = 0;
  botDoubleAttempts = 0;
  let totalTurnScore = 0;
  const wuerfe = [];

  for (let i = 0; i < 3; i++) {
    botDartsThrownThisTurn++;
    let currentRest = localP2Score - totalTurnScore;
    let target = getBotTarget(currentRest);

    if ((currentRest <= 40 && currentRest % 2 === 0) || currentRest === 50) {
      botDoubleAttempts++;
    }

    const dart = calculateBotHit(target, botDifficulty501);
    totalTurnScore += dart.points;
    wuerfe.push(dart);

    // Dart fuer Dart sichtbar - in DENSELBEN drei Kacheln, in denen auch die
    // eigenen Darts stehen. Vorher stand hier nur die Punktzahl im
    // Ziffernblock-Feld, und das ist in der Board-Eingabe gar nicht sichtbar:
    // Der Bot warf dann fuer den Zuschauer aus dem Nichts eine Summe.
    if (typeof window.boardBotDarts === "function") window.boardBotDarts(wuerfe);
    const anzeige = document.getElementById("input-display-501");
    if (anzeige) {
      anzeige.innerText =
        wuerfe.map((d) => d.label).join(" · ") + "  =  " + totalTurnScore;
    }

    // Pause zwischen den Darts
    await new Promise((r) => (botTimer501 = setTimeout(r, 800)));
    if (!isLocal501) return; // Falls währenddessen abgebrochen wurde

    let tempScore = localP2Score - totalTurnScore;
    if (tempScore <= 1 || tempScore === 0) break;
  }

  // Die letzte Aufnahme noch einen Moment stehen lassen, sonst ist sie im
  // selben Wimpernschlag weg, in dem sie vollstaendig wurde.
  await new Promise((r) => (botTimer501 = setTimeout(r, 500)));
  if (!isLocal501) return;

  // UI wieder freigeben und Score absenden
  if (isLocal501) {
    if (numpad) numpad.style.pointerEvents = "auto";
    if (presets) presets.style.pointerEvents = "auto";
    if (typeof window.boardBotDarts === "function") window.boardBotDarts(null);
    current501Input = totalTurnScore.toString();
    submit501Score();
  }
}

function getBotTarget(remaining) {
  // 1. Scoring Phase
  if (remaining > 170) return 60; // Immer T20

  // 2. Spezielle Finish-Bereiche (High-Outs)
  if (remaining === 170) return 60; // T20 -> T20 -> Bull
  if (remaining > 50 && remaining <= 60) return remaining; // z.B. 52 -> D26 (wenn Bot das kann) oder Single 12
  if (remaining === 50) return 50; // Bullseye-Finish

  // 3. Setup Phase (Der "46-Rest" Fix)
  // Wenn wir über 40 sind, wollen wir uns auf ein schönes Doppel stellen (meistens D20 = 40)
  if (remaining > 40 && remaining < 170) {
    // Wir versuchen den Rest so zu reduzieren, dass 40 (D20) oder 32 (D16) übrig bleibt
    if (remaining > 60) return 60; // Weiter T20 bis wir im Bereich 41-60 sind

    let setupTarget = remaining - 40; // Ziel, um 40 Rest zu lassen
    // Falls das Setup-Ziel ungerade ist (z.B. bei 41 Rest -> Ziel 1), ist das okay.
    return setupTarget;
  }

  // 4. Checkout Phase (Rest <= 40)
  if (remaining <= 40 && remaining % 2 === 0) {
    return remaining; // Das Ziel ist das Doppel (z.B. 40 für D20)
  }

  // 5. Notlösung für ungerade Reste unter 40
  if (remaining < 40 && remaining % 2 !== 0) {
    return 1; // 1 werfen, um auf ein Doppel zu kommen
  }

  return 60; // Fallback
}

/** Das Feld, auf das der Bot bei einem Setup-Wurf tatsaechlich zielen kann.
 *
 *  BEFUND 15.08.2026: getBotTarget() liefert fuer Reste von 51-60 den Rest
 *  selbst als Ziel ("check das in einem Dart"). Fuer 52, 53, 55, 56, 58 und
 *  59 gibt es dieses Feld aber gar nicht - der Bot "traf" dann eine 52 mit
 *  einem Dart. In der Summe fiel das nie auf; dartweise angezeigt waere es
 *  offensichtlicher Unsinn.
 *
 *  Er zielt in dem Fall auf die 20 - genau das, was ein Mensch tut: von 52
 *  auf 32 stellen und das Doppel 16 nehmen.
 *
 *  Bleibt hier und wandert NICHT nach bot.js: Das ist Zielwahl im 501, kein
 *  Koennen. Ein Bot in Bob's 27 hat damit nichts zu tun. */
function botSetupFeld(target) {
  if (target === 25 || target === 50) return target;
  if (target >= 1 && target <= 20) return target;
  return 20;
}

/** Ein Dart des Bots. Zielwahl bleibt hier, das KOENNEN kommt aus bot.js.
 *
 *  UMBAU 15.08.2026: Die Trefferquoten standen frueher als rohe Zahlen in
 *  dieser Funktion - dieselben Groessen, die in Secure noch einmal und ganz
 *  anders dastanden. Jetzt entscheidet hier nur noch, WORAUF der Bot zielt
 *  (Doppel, Triple oder Stellwurf); WIE OFT er trifft, beantwortet das
 *  gemeinsame Modell. Die Formeln sind woertlich dieselben geblieben - der
 *  501-Bot ist nach dem Umbau exakt so stark wie vorher.
 *
 *  `rnd` wird durchgereicht, damit ein Test eine Grenze genau treffen kann,
 *  statt zehntausend Mal zu wuerfeln. */
function calculateBotHit(target, avg, rnd = Math.random() * 100) {
  // Zielt der Bot gerade auf ein DOPPEL? Genau dann, wenn das Ziel dem
  // Rest entspricht und mit einem Dart auszumachen ist.
  const istCheckout = (target <= 40 && target % 2 === 0) || target === 50;
  if (istCheckout) return window.wurfAufDoppel(avg, target, rnd);

  // Scoring: T20 und andere durch drei teilbare Ziele ueber 40.
  if (target === 60 || (target > 40 && target % 3 === 0)) {
    return window.wurfAufTriple(avg, target / 3, rnd);
  }

  // Stellwurf auf ein Single-Feld.
  return window.wurfAufSingle(avg, botSetupFeld(target), rnd);
}

async function triggerOnlineMatchStart() {
  if (!isOnlineHost) return;

  document.getElementById("btn-start-online-match").innerText = t("js.camera.005");
  document.getElementById("btn-start-online-match").disabled = true;

  // Ändert den Status auf "playing", was bei beiden Spielern das Spiel öffnet
  await _supabase
    .from("live_matches")
    .update({
      status: "playing",
      last_action: t("js.camera.006"),
    })
    .eq("room_code", currentRoomCode);
}

function stopLocalGameLogic() {
  if (botTimer501) {
    clearTimeout(botTimer501);
    botTimer501 = null;
  }
  isLocal501 = false;
  isP2Bot = false;

  // UI sicherheitshalber entsperren
  const numpad = document.querySelector(".numpad-grid");
  const presets = document.querySelector(".preset-grid");
  if (numpad) numpad.style.pointerEvents = "auto";
  if (presets) presets.style.pointerEvents = "auto";
}

async function verifyLocalPlayer2_501() {
  openPairingInputModal(async (code) => {
    // Validierung über die neue SQL-Funktion aufrufen
    const { data, error } = await _supabase.rpc("verify_pairing_code", {
      p_code: code,
    });

    if (error || !data || data.length === 0) {
      if (typeof showToast === "function")
        showToast(t("js.g501.018"), "error");
      return;
    }

    const guestData = data[0];
    localP2Id = guestData.user_id;

    // 1. Avatar URL bestimmen (Datenbank ODER generierter Fallback)
    localP2AvatarUrl =
      guestData.avatar_url ||
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${guestData.name}`;

    // 2. Das Eingabefeld im Setup-Screen updaten
    const p2Input = document.getElementById("local-p2-name");
    if (p2Input) {
      p2Input.value = guestData.name;
      p2Input.disabled = true;
    }

    // 3. NEU: Den Avatar schon mal in das <img> Tag des versteckten Game-Screens laden!
    const gameAvatarP2 = document.getElementById("avatar-p2");
    if (gameAvatarP2) {
      gameAvatarP2.src = localP2AvatarUrl;
    }

    if (typeof showToast === "function") {
      showToast(
        tf("js.g501.031", { p1: guestData.name }),
        "success"
      );
    }
  });
}

// ==========================================
// DART-FÜR-DART TASCHENRECHNER LOGIK
// ==========================================

// Umschalter Board <-> Tastatur (07.08.2026, Aufgabe 2):
// Das alte Modus-Geruest (numpad/calc/auto) hing seit dem Wegfall des
// Umschalt-Knopfs in der Luft - "numpad-container-501" existiert im HTML
// gar nicht mehr, und "auto" haette den halbfertigen Autoscore-Container
// aktiviert. Jetzt gibt es genau die zwei Eingabearten, die es im HTML
// auch gibt: das klickbare Board und die Dart-fuer-Dart-Tastatur
// (calc-container). Auto-Scoring bleibt UNBERUEHRT: autoscore.js
// verwaltet seinen Container weiterhin selbst (autoScore.setActive),
// dieser Umschalter fasst ihn nicht an.
let inputMode501 = "board"; // 'board' oder 'calc'
let calcDarts = [];
let calcCurrentMult = 1;

const INPUT_MODES_501 = ["board", "calc"];

// Funktion statt Konstante: Ein beim Modul-Laden gefuelltes Objekt friert
// die Sprache auf den Ladezeitpunkt ein - nach einem Sprachwechsel stuende
// dann noch "Tastatur" auf dem Knopf.
function inputModeLabel501(modus) {
  return modus === "board" ? t("js.g501.036") : t("js.g501.037");
}

/** Wertet der Tracker gerade fuer DIESES Fenster?
 *
 * Dann ist ER die Eingabe, und ein zweites Eingabefeld daneben ist eine
 * Einladung, denselben Wurf zweimal zu zaehlen. Alle drei Bedingungen
 * sind noetig:
 *
 *   active    - Auto-Scoring ueberhaupt eingeschaltet (hello empfangen)
 *   verbunden - der Tracker laeuft JETZT. Faellt er mitten im Leg aus,
 *               muss die Handeingabe sofort zurueck sein - sonst steht
 *               der Spieler vor einem Bildschirm ohne Eingabe.
 *   wertend   - kein anderes Fenster hat die Wertung uebernommen.
 */
function trackerWertet501() {
  const s = window.autoScore && window.autoScore.state;
  return Boolean(s && s.active && s.wertend && s.connection === "verbunden");
}

const INPUT_MODE_KEY_501 = "secure-darts:input-501";

function toggle501InputMode() {
  const index = INPUT_MODES_501.indexOf(inputMode501);
  inputMode501 = INPUT_MODES_501[(index + 1) % INPUT_MODES_501.length];
  try {
    // Bevorzugte Eingabeart merken - gilt beim naechsten Spiel/Reload weiter.
    localStorage.setItem(INPUT_MODE_KEY_501, inputMode501);
  } catch (error) {
    // Gesperrter Speicher: Auswahl gilt dann nur fuer diese Sitzung.
  }
  applyInputMode501();
}

/** Genau EIN Eingabefeld sichtbar machen.
 *
 * Billig und beliebig oft aufrufbar - autoscore.js ruft das bei jeder
 * Zustandsaenderung auf. Bewusst OHNE resetCalcState(): Das gehoert zum
 * Moduswechsel des Nutzers, nicht zu jedem Trackerereignis; sonst waere
 * die halbfertige Dart-fuer-Dart-Eingabe bei jedem Wurf geloescht. */
function aktualisiere501Eingabe() {
  const show = (id, visible) => {
    const node = document.getElementById(id);
    if (node) node.style.display = visible ? "block" : "none";
  };

  const tracker = trackerWertet501();

  // Das Board bleibt bei laufendem Tracker STEHEN - aber als reine
  // Anzeige. Grund: Die erkannten Darts werden in genau dieses SVG
  // gezeichnet (boardLiveDarts501, boardTrackerMark501 in board-input.js).
  // Wer es ausblendet, nimmt dem Spieler die Sichtkontrolle, wo der Pfeil
  // gelandet ist - die wichtigste Rueckmeldung des Trackers ueberhaupt.
  // Weg muessen nur die BEDIENELEMENTE: die drei Wurffelder und Miss/Next
  // oben im Board (.board-topbar) doppeln den Trackerkasten, und ein Klick
  // auf die Scheibe wuerde einen vierten Dart erfinden.
  show("board-container-501", tracker || inputMode501 === "board");
  show("calc-container-501", !tracker && inputMode501 === "calc");

  const board = document.getElementById("board-container-501");
  if (board) board.classList.toggle("is-nur-anzeige", tracker);

  // Der Umschalter waere waehrend des Trackerbetriebs eine Wahl ohne
  // Wirkung. Ihn wirkungslos stehen zu lassen waere schlimmer als ihn
  // wegzunehmen - er kommt zurueck, sobald der Tracker weg ist.
  const reihe = document.querySelector("#game-501-screen .input-mode-row");
  if (reihe) reihe.style.display = tracker ? "none" : "";

  // Der Knopf nennt die NAECHSTE Eingabeart, nicht die aktuelle - sonst
  // liest man "Board" waehrend das Board offen ist.
  const next =
    INPUT_MODES_501[
      (INPUT_MODES_501.indexOf(inputMode501) + 1) % INPUT_MODES_501.length
    ];
  const label = document.getElementById("toggle-input-text");
  if (label) {
    label.textContent = tf("js.g501.eingabeart", {
      p1: inputModeLabel501(next),
    });
  }
}

function applyInputMode501() {
  aktualisiere501Eingabe();
  resetCalcState();
}

// Gespeicherte Eingabeart beim Laden uebernehmen (Standard: Board).
if (typeof document !== "undefined") {
  try {
    const stored = localStorage.getItem(INPUT_MODE_KEY_501);
    if (INPUT_MODES_501.includes(stored)) inputMode501 = stored;
  } catch (error) {
    // Kein Zugriff auf localStorage - beim Standard bleiben.
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyInputMode501);
  } else {
    applyInputMode501();
  }
}

function setCalcMult(m) {
  calcCurrentMult = m;
  document.getElementById("calc-mult-1").style.borderColor =
    m === 1 ? "var(--accent-blue)" : "transparent";
  document.getElementById("calc-mult-2").style.borderColor =
    m === 2 ? "var(--accent-green)" : "transparent";
  document.getElementById("calc-mult-3").style.borderColor =
    m === 3 ? "var(--accent-red)" : "transparent";
}

function addCalcDart(val) {
  // Verhindern, dass man tippt, wenn der Gegner dran ist
  if (!isLocal501 && !isMyTurn) return;
  if (calcDarts.length >= 3) return;

  // Spezielle Regeln (Idioten-Sicher)
  let mult = calcCurrentMult;
  if (val === 25 || val === 50 || val === 0) {
    mult = 1; // Bull, Bullseye und Miss haben keine eigenen Multiplikatoren hier
  }

  let label = val.toString();
  if (val === 25) label = "BULL";
  else if (val === 50) label = "B-EYE";
  else if (val === 0) label = "MISS";
  else {
    if (mult === 2) label = "D" + val;
    if (mult === 3) label = "T" + val;
  }

  let points = val * mult;
  // base/mult mitfuehren (29.08.2026): Daraus erkennt submit501Score
  // Doppel und Triple fuer die Finish-Regel. Bullseye traegt base 50.
  calcDarts.push({ val: points, base: val, mult: mult, label: label });

  setCalcMult(1); // Setzt den Multiplikator nach jedem Pfeil automatisch auf Single zurück
  updateCalcUI();
}

function delCalcDart() {
  if (!isLocal501 && !isMyTurn) return;
  calcDarts.pop();
  updateCalcUI();
}

function updateCalcUI() {
  let sum = 0;
  for (let i = 1; i <= 3; i++) {
    let box = document.getElementById("calc-box-" + i);
    if (calcDarts[i - 1]) {
      // Fehlwuerfe werden durchnummeriert: M1, M2, M3 statt dreimal "MISS".
      // NUR DIE ANZEIGE aendert sich - das gespeicherte label bleibt "MISS",
      // sonst brechen die Farbregeln weiter unten (=== "MISS") still ab.
      box.innerText =
        calcDarts[i - 1].label === "MISS" ? "M" + i : calcDarts[i - 1].label;

      // Box Farbe anpassen basierend auf Treffer
      if (
        calcDarts[i - 1].label.startsWith("T") ||
        calcDarts[i - 1].label === "B-EYE"
      )
        box.style.color = "var(--accent-red)";
      else if (
        calcDarts[i - 1].label.startsWith("D") ||
        calcDarts[i - 1].label === "BULL"
      )
        box.style.color = "var(--accent-green)";
      else if (calcDarts[i - 1].label === "MISS") box.style.color = "#888";
      else box.style.color = "white";

      sum += calcDarts[i - 1].val;
    } else {
      box.innerText = "-";
      box.style.color = "white";
    }
  }
  document.getElementById("calc-sum-display").innerText = sum;
}

function submitCalcDarts() {
  if (!isLocal501 && !isMyTurn) return;
  if (calcDarts.length === 0) return; // Nichts geworfen

  // Addiert alle Pfeile zusammen
  let sum = calcDarts.reduce((acc, dart) => acc + dart.val, 0);

  // Übergebe die Summe an die exakt selbe Funktion wie beim normalen Numpad!
  // Seit 29.08.2026 samt Dartliste - Finish-Regel + echte Dartzahl.
  submit501Score(sum, { darts: calcDarts.slice() });

  resetCalcState();
}

function resetCalcState() {
  calcDarts = [];
  setCalcMult(1);
  updateCalcUI();
}

// ---------------------------------------------------------------
// ── Auto-Score-Adapter (autoscore.js, Registry seit 13.08.2026) ────────────
// 501 ist der erste Abnehmer der Registry: pro Dart die Live-Wertung
// (Bust/Finish sofort), die Aufnahme geht wie bisher durch submit501Score.
// Der Eingabeart-Schalter (Ziffernblock/Board/Auto) bleibt in autoscore.js.
window.autoScoreAdapter = window.autoScoreAdapter || {};
window.autoScoreAdapter["501"] = {
  korrigierbar: true,
  aktiv: () =>
    document.getElementById("game-501-screen")?.style.display !== "none",
  // Urspruengliche DOM-Position des Autoscore-Kastens: direkt vor der
  // Boardeingabe. Dorthin kehrt er zurueck, wenn 501 wieder dran ist.
  ziel: () => document.getElementById("board-container-501"),
  dart: (dart, summe, anzahl) => autoscore501Dart(dart, summe, anzahl),
  // wuerfe seit 29.08.2026 mitgereicht: Finish-Regel + echte Dartzahl.
  aufnahme: (summe, wuerfe, optionen) =>
    submit501Score(summe, { ...optionen, darts: wuerfe }),
  // ── Live-Anzeige (13.08.2026 abends) ────────────────────────────────
  // Waehrend der Kameraerkennung pulsiert der aktuell gesehene Dart auf
  // dem Eingabe-Board; mit der endgueltigen Zaehlung (markiere) geht er
  // in eine normale Treffermarke ueber. Beides reine Anzeige in
  // board-input.js/dartboard.js - die Wertung laeuft unveraendert oben.
  live: (darts) => window.boardLiveDarts501?.(darts),
  markiere: (dart) => {
    if (dart && dart.heat) {
      window.boardTrackerMark501?.(dart.heat.x_mm, dart.heat.y_mm, dart.label);
    }
  },
  geleert: () => window.boardTrackerGeleert501?.(),
};

// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  resetStatsTracker,
  aktualisiere501Eingabe,
  trackerWertet501,
  mindestDarts501,
  aktuellerWerfer501,
  eigenerRest501,
  autoscore501Dart,
  startLocal501Game,
  getCheckoutPath,
  hostOnlineGame,
  joinOnlineGame,
  cancelLobby,
  sync501UI,
  append501Input,
  set501Input,
  delete501Input,
  submit501Score,
  listenForOpponent,
  cancel501Game,
  requestUndo,
  startNextLeg,
  triggerRematch,
  add501Bot,
  changeBotAvg,
  setzeBotAvg,
  cancelBotSetup,
  confirmBotSetup,
  triggerOnlineMatchStart,
  stopLocalGameLogic,
  verifyLocalPlayer2_501,
  toggle501InputMode,
  applyInputMode501,
  setCalcMult,
  addCalcDart,
  delCalcDart,
  submitCalcDarts,
});
